// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import withPermission from '../../utils/withPermission';
// import ReactPaginate from 'react-paginate';
// import { Link } from 'react-router-dom';
// import Swal from "sweetalert2";
// import { FaFilter } from "react-icons/fa";

// const InvoiceList = () => {
//     const [activeTab, setActiveTab] = useState("proforma"); // Default to proforma invoices
//     const [proformaInvoices, setPerformaInvoices] = useState([]);
//     const [taxInvoices, setTaxInvoice] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [currentPage, setCurrentPage] = useState(0);
//     const [pageCount, setPageCount] = useState(0);
//     const [organisations, setOrganisation] = useState([]);
//     const [errors, setErrors] = useState({});
//     const [contacts, setContacts] = useState([]);
//     const WithCreatePermission = withPermission(({ children }) => children, ['proformainvoice-create']);
//     const WithEditPermission = withPermission(({ children }) => children, ['proformainvoice-edit']);
//     const WithDeletePermission = withPermission(({ children }) => children, ['proformainvoice-delete']);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [selectedProject, setSelectedProject] = useState('');
//     const [projects, setProjects] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
//     const [dateRange, setDateRange] = useState({ from: '', to: '' });
//     const [taxPagination, setTaxPagination] = useState({
//         currentPage: 0,
//         pageCount: 0
//     });
//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);

//     };
//     const fetchProjects = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/projects`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             setProjects(response.data.Data || []);
//         } catch (error) {
//             console.error("Error fetching projects:", error);
//         }
//     };
//     useEffect(() => {
//         fetchProjects();
//     }, []);
//     const fetchPerformaInvoices = async (page = 1, projectId = "", dateRange = {}) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             // Build params dynamically (only include if they have values)
//             let params = { page };

//             if (projectId) params.project_id = projectId;
//             if (dateRange?.from) params.from_date = dateRange.from;
//             if (dateRange?.to) params.to_date = dateRange.to;


//             console.log("Fetching Proforma Invoices with params:", params); // Debugging

//             const response = await axios.get(`${backendUrl}/api/proformainvoice`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params
//             });

//             const proformaInvoiceData = response.data.proformainvoice?.data || {};
//             const invoices = proformaInvoiceData.data || [];
//             const currentPage = proformaInvoiceData.current_page || 1;
//             const lastPage = proformaInvoiceData.last_page || 1;

//             setPerformaInvoices(invoices);
//             setCurrentPage(currentPage);
//             setPageCount(lastPage);
//         } catch (error) {
//             console.error("Error fetching proforma invoices:", error);
//         }
//     };


//     const fetchTaxInvoices = async (page = 1, projectId = "", dateRange = {}) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             let params = { page };

//             if (projectId) params.project_id = projectId;
//             if (dateRange?.from) params.from_date = dateRange.from;
//             if (dateRange?.to) params.to_date = dateRange.to;
//             console.log("Sending API Request with params:", params);
//             const response = await axios.get(`${backendUrl}/api/taxinvoices`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 params
//             });

//             if (response.data.status === "success") {
//                 setTaxInvoice(response.data.taxinvoices?.data || []);
//                 setTaxPagination({
//                     currentPage: response.data.taxinvoices?.current_page || 1,
//                     pageCount: response.data.taxinvoices?.last_page || 1
//                 });
//             }
//         } catch (error) {
//             console.error("Error fetching tax invoices:", error);
//         } finally {
//             setLoading(false);
//         }
//     };
//     const handlePageClick = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchPerformaInvoices(selectedPage);

//     };
//     const handlePageClick1 = (data) => {
//         const selectedPage = data.selected + 1;
//         fetchTaxInvoices(selectedPage);

//     };
//     // useEffect(() => {
//     //     fetchPerformaInvoices(1);
//     //     fetchTaxInvoices();
//     // }, []);




//     if (loading) {
//         return <p>Loading invoices...</p>;
//     }
//     // const deleteProformaInvoice = async (id) => {

//     //     const result = await Swal.fire({
//     //         title: "Are you sure?",
//     //         text: "You won't be able to revert this!",
//     //         icon: "warning",
//     //         showCancelButton: true,
//     //         confirmButtonColor: "#d33",
//     //         cancelButtonColor: "#3085d6",
//     //         confirmButtonText: "Yes, delete it!",
//     //         cancelButtonText: "Cancel"
//     //     });


//     //     if (!result.isConfirmed) {
//     //         return; // Exit if the user cancels
//     //     }

//     //     try {
//     //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     //         const userInfo = JSON.parse(localStorage.getItem('user-info'));
//     //         const origin = localStorage.getItem('user-origin');

//     //         const token = userInfo?.token;

//     //         await axios.delete(`${backendUrl}/api/proformainvoice/${id}`, {
//     //             headers: { Authorization: `Bearer ${token}` ,
//     //             'Tenant-Origin': origin,

//     //         },
//     //         });

//     //         // Remove from UI
//     //         setPerformaInvoices((prevInvoices) =>
//     //             prevInvoices.filter(invoice => invoice.id !== id)
//     //         );

//     //         console.log("Delete successful!");

//     //         // Show success alert
//     //         Swal.fire("Deleted!", "The proforma invoice has been deleted.", "success");

//     //     } catch (error) {
//     //         console.error('Error deleting proforma invoice:', error);

//     //         Swal.fire("Error!", "Failed to delete proforma invoice. Please try again.", "error");
//     //     }
//     // };
//     const deleteProformaInvoice = async (id, journalId) => {
//         console.log("Delete function triggered"); // Debugging

//         const result = await Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!",
//             cancelButtonText: "Cancel"
//         });

//         console.log("Swal result:", result); // Debugging

//         if (!result.isConfirmed) {
//             console.log("Delete cancelled");
//             return; // Exit if the user cancels
//         }

//         try {
//             console.log("Sending DELETE request...");
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;
//             const API = process.env.REACT_APP_WEBZASH_URL;
//             const API_KEY = process.env.REACT_APP_API_KEY;

//             await axios.delete(`${backendUrl}/api/proformainvoice/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             if (journalId) {
//                 await axios.delete(`${API}/api/entries/delete/journal/${journalId}`, {
//                     headers: {
//                         'x-api-key': API_KEY,
//                         Accept: 'application/json',
//                         'Content-Type': 'application/json',
//                     }
//                 });
//             }
//             // Remove from UI
//             setPerformaInvoices((prevInvoices) =>
//                 prevInvoices.filter(invoice => invoice.id !== id)
//             );

//             console.log("Delete successful!");

//             // Show success alert
//             Swal.fire("Deleted!", "The proforma invoice has been deleted.", "success");

//         } catch (error) {
//             console.error('Error deleting proforma invoice:', error);

//             Swal.fire("Error!", "Failed to delete proforma invoice. Please try again.", "error");
//         }
//     };

//     const deleteTaxInvoice = async (id) => {

//         const result = await Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!",
//             cancelButtonText: "Cancel"
//         });


//         if (!result.isConfirmed) {
//             return; // Exit if the user cancels
//         }

//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             await axios.delete(`${backendUrl}/api/taxinvoices/${id}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             // Remove from UI
//             setTaxInvoice((prevInvoices) =>
//                 prevInvoices.filter(invoice => invoice.id !== id)
//             );

//             console.log("Delete successful!");

//             // Show success alert
//             Swal.fire("Deleted!", "The tax invoice has been deleted.", "success");

//         } catch (error) {

//             Swal.fire("Error!", "Failed to delete tax invoice. Please try again.", "error");
//         }
//     };
//     const clearDateFilter = () => {
//         setDateRange({ from: "", to: "" }); // Reset date inputs
//     };
//     const handleDateChange = (e) => {
//         const { name, value } = e.target;
//         setDateRange((prev) => ({ ...prev, [name]: value }));
//     };
//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-18">
//                                     Invoices
//                                 </h4>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="tabs-container mb-2">
//                         <button
//                             className={`tab-button ${activeTab === "proforma" ? "active" : ""}`}
//                             onClick={() => setActiveTab("proforma")}
//                         >
//                             Proforma Invoice
//                         </button>
//                         <button
//                             className={`tab-button ${activeTab === "tax" ? "active" : ""}`}
//                             onClick={() => setActiveTab("tax")}
//                         >
//                             Tax Invoice
//                         </button>
//                     </div>

//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between mb-3">
//                                         <div className="d-flex">
//                                             <div className="search-box me-2 mb-2 d-inline-block">
//                                                 <div className="position-relative">
//                                                     {/* <input
//                                                         type="text"
//                                                         className="form-control"
//                                                         placeholder="Search..."
//                                                         value={searchQuery}
//                                                         onChange={handleSearchChange}
//                                                     />
//                                                     <i className="bx bx-search-alt search-icon" /> */}
//                                                 </div>
//                                             </div>



//                                         </div><br />

//                                         {/* <WithCreatePermission>
//                                         <button
//                                             type="button"
//                                             className="btn btn-secondary btn-rounded waves-effect waves-light mb-3"
//                                             onClick={() => handleShowModal()}
//                                         >
//                                             <i className="mdi mdi-plus me-1"></i> Add
//                                         </button></WithCreatePermission> */}
//                                     </div>
//                                     {activeTab === "proforma" ? (
//                                         <div>
//                                             <table className="table align-middle table-nowrap table-check table-list">
//                                                 <thead className="table-sales-gradient">
//                                                     <tr>
//                                                         <th style={{ width: '20px' }} className="align-middle">
//                                                             <div className="form-check font-size-16">
//                                                                 <input className="form-check-input" type="checkbox" id="checkAll" />
//                                                                 <label className="form-check-label" htmlFor="checkAll"></label>
//                                                             </div>
//                                                         </th>
//                                                         <th className="align-middle">#</th>
//                                                         <th className="align-middle">
//                                                             Date
//                                                             <div className="dropdown d-inline-block">
//                                                                 <FaFilter
//                                                                     className="ms-2 cursor-pointer filter-color"
//                                                                     onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
//                                                                 />
//                                                                 {dateFilterDropdown && (
//                                                                     <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
//                                                                         <label className="form-label">From</label>
//                                                                         <input type="date" className="form-control mb-2" name="from" value={dateRange.from} onChange={handleDateChange} />

//                                                                         <label className="form-label">To</label>
//                                                                         <input type="date" className="form-control mb-2" name="to" value={dateRange.to} onChange={handleDateChange} />

//                                                                         <div className="text-end mt-3">
//                                                                             <button className="btn btn-primary btn-sm d-inline-block w-auto me-2"
//                                                                                 onClick={() => {
//                                                                                     if (activeTab === "proforma") {
//                                                                                         fetchPerformaInvoices(currentPage, selectedProject, dateRange);
//                                                                                     } else if (activeTab === "tax") {
//                                                                                         fetchTaxInvoices(currentPage, selectedProject, dateRange);
//                                                                                     }
//                                                                                     setDateFilterDropdown(false);
//                                                                                 }}>
//                                                                                 Apply
//                                                                             </button>
//                                                                             <button className="btn btn-secondary btn-sm d-inline-block w-auto" onClick={clearDateFilter}>
//                                                                                 Clear
//                                                                             </button>
//                                                                         </div>
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </th>

//                                                         <th className="align-middle">Reference No</th>
//                                                         <th className="align-middle">Quotation</th>

//                                                         <th className="align-middle">Customer</th>
//                                                         <th className="align-middle">
//                                                             Project
//                                                             <div className="d-inline-block position-relative">
//                                                                 <FaFilter
//                                                                     className="ms-2 cursor-pointer filter-color"
//                                                                     onClick={() => setShowDropdown(!showDropdown)}
//                                                                 />
//                                                                 {showDropdown && (
//                                                                     <div className="position-absolute mt-2 bg-white border rounded shadow p-2" style={{ minWidth: "150px", zIndex: 10 }}>
//                                                                         <select
//                                                                             className="form-control"
//                                                                             value={selectedProject}
//                                                                             onChange={(e) => {
//                                                                                 setSelectedProject(e.target.value);
//                                                                                 if (activeTab === "proforma") {
//                                                                                     fetchPerformaInvoices(currentPage, e.target.value, dateRange);
//                                                                                 } else if (activeTab === "tax") {
//                                                                                     fetchTaxInvoices(e.target.value, dateRange);
//                                                                                 }
//                                                                                 setShowDropdown(false); // Hide dropdown after selection
//                                                                             }}

//                                                                         // size={projects.length} // Show all options at once

//                                                                         >
//                                                                             <option value="">All Projects</option>

//                                                                             {projects.map((project) => (
//                                                                                 <option key={project.id} value={project.id}>
//                                                                                     {project.name}
//                                                                                 </option>
//                                                                             ))}
//                                                                         </select>

//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </th>

//                                                         <th className="align-middle">Advanced Amount</th>


//                                                         <th className="align-middle">Action</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {proformaInvoices.length > 0 ? (
//                                                         proformaInvoices.map((proformainvoice, index) => (
//                                                             <tr key={proformainvoice.id}>
//                                                                 <td>
//                                                                     <div className="form-check font-size-16">
//                                                                         <input
//                                                                             className="form-check-input"
//                                                                             type="checkbox"
//                                                                             id={`proformainvoiceCheck${index}`}
//                                                                         />
//                                                                         <label
//                                                                             className="form-check-label"
//                                                                             htmlFor={`proformainvoiceCheck${index}`}
//                                                                         ></label>
//                                                                     </div>
//                                                                 </td>
//                                                                 <td>{index + 1}</td>

//                                                                 <td>
//                                                                     <Link to={`/proformainvoice/details/${proformainvoice.id}`} className="dropdown-item">
//                                                                         {new Date(proformainvoice.created_at).toLocaleDateString()}
//                                                                     </Link>
//                                                                 </td>

//                                                                 <td><Link to={`/proformainvoice/details/${proformainvoice.id}`} className="dropdown-item">
//                                                                     {proformainvoice.ref_no}</Link></td>
//                                                                 <td><Link to={`/quotation/details/${proformainvoice.quotation_id}`} className="dropdown-item">{proformainvoice.quotation?.ref_no}</Link></td>

//                                                                 <td>{proformainvoice?.quotation.project?.client?.name}</td>
//                                                                 <td>{proformainvoice?.quotation.project?.name}</td>
//                                                                 <td>{proformainvoice.advanced_amount}%</td>



//                                                                 <td>
//                                                                     <div className="dropdown">
//                                                                         <i
//                                                                             className="mdi mdi-dots-horizontal font-size-18"
//                                                                             data-bs-toggle="dropdown"
//                                                                             aria-expanded="false"
//                                                                             style={{ cursor: 'pointer' }}
//                                                                         ></i>
//                                                                         <ul className="dropdown-menu dropdown-menu-end font-size-14">
//                                                                             <li>
//                                                                                 <Link to={`/proformainvoice/details/${proformainvoice.id}`} className="dropdown-item">
//                                                                                     View Details
//                                                                                 </Link>
//                                                                             </li>

//                                                                             <li><WithDeletePermission>
//                                                                                 <button
//                                                                                     className="dropdown-item"
//                                                                                     onClick={() => deleteProformaInvoice(proformainvoice.id,proformainvoice.journal_id)}
//                                                                                 >
//                                                                                     Delete
//                                                                                 </button></WithDeletePermission>
//                                                                             </li>
//                                                                         </ul>
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                         ))
//                                                     ) : (
//                                                         <tr>
//                                                             <td colSpan="5" className="text-center">No proformainvoices found.</td>
//                                                         </tr>
//                                                     )}
//                                                 </tbody>
//                                             </table>
//                                             <div className="d-flex justify-content-end pagination-sm">
//                                                 <ReactPaginate
//                                                     previousLabel={'<'}
//                                                     nextLabel={'>'}
//                                                     breakLabel={'...'}
//                                                     pageCount={pageCount}
//                                                     marginPagesDisplayed={2}
//                                                     pageRangeDisplayed={3}
//                                                     onPageChange={handlePageClick}
//                                                     containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                                                     pageClassName={'page-item'}
//                                                     pageLinkClassName={'page-link'}
//                                                     previousClassName={'page-item previous'}
//                                                     previousLinkClassName={'page-link'}
//                                                     nextClassName={'page-item next'}
//                                                     nextLinkClassName={'page-link'}
//                                                     breakClassName={'page-item'}
//                                                     breakLinkClassName={'page-link'}
//                                                     activeClassName={'active'}
//                                                 />
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <div>
//                                             <table className="table align-middle table-nowrap table-check table-list">
//                                                 <thead className="table-sales-gradient">
//                                                     <tr>
//                                                         <th style={{ width: '20px' }} className="align-middle">
//                                                             <div className="form-check font-size-16">
//                                                                 <input className="form-check-input" type="checkbox" id="checkAll" />
//                                                                 <label className="form-check-label" htmlFor="checkAll"></label>
//                                                             </div>
//                                                         </th>
//                                                         <th>#</th>
//                                                         <th className="align-middle">
//                                                             Date
//                                                             <div className="dropdown d-inline-block">
//                                                                 <FaFilter
//                                                                     className="ms-2 cursor-pointer filter-color"
//                                                                     onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
//                                                                 />
//                                                                 {dateFilterDropdown && (
//                                                                     <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
//                                                                         <label className="form-label">From</label>
//                                                                         <input type="date" className="form-control mb-2" name="from" value={dateRange.from} onChange={handleDateChange} />

//                                                                         <label className="form-label">To</label>
//                                                                         <input type="date" className="form-control mb-2" name="to" value={dateRange.to} onChange={handleDateChange} />

//                                                                         <div className="text-end mt-3">
//                                                                             <button className="btn btn-primary btn-sm d-inline-block w-auto me-2"
//                                                                                 onClick={() => {
//                                                                                     if (activeTab === "proforma") {
//                                                                                         fetchPerformaInvoices(currentPage, selectedProject, dateRange);
//                                                                                     } else if (activeTab === "tax") {
//                                                                                         fetchTaxInvoices(currentPage, selectedProject, dateRange);
//                                                                                     }
//                                                                                     setDateFilterDropdown(false);
//                                                                                 }}>
//                                                                                 Apply
//                                                                             </button>
//                                                                             <button className="btn btn-secondary btn-sm d-inline-block w-auto" onClick={clearDateFilter}>
//                                                                                 Clear
//                                                                             </button>
//                                                                         </div>
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </th>                                                    <th>Reference No</th>
//                                                         <th>Customer</th>
//                                                         <th className="align-middle">
//                                                             Project
//                                                             <div className="d-inline-block position-relative">
//                                                                 <FaFilter
//                                                                     className="ms-2 cursor-pointer filter-color"
//                                                                     onClick={() => setShowDropdown(!showDropdown)}
//                                                                 />
//                                                                 {showDropdown && (
//                                                                     <div className="position-absolute mt-2 bg-white border rounded shadow p-2" style={{ minWidth: "150px", zIndex: 10 }}>
//                                                                         <select
//                                                                             className="form-control"
//                                                                             value={selectedProject}
//                                                                             onChange={(e) => {
//                                                                                 setSelectedProject(e.target.value);
//                                                                                 if (activeTab === "proforma") {
//                                                                                     fetchPerformaInvoices(currentPage, e.target.value, dateRange);
//                                                                                 } else if (activeTab === "tax") {
//                                                                                     fetchTaxInvoices(e.target.value, dateRange);
//                                                                                 }
//                                                                                 setShowDropdown(false); // Hide dropdown after selection
//                                                                             }}
//                                                                         // size={projects.length} // Show all options at once

//                                                                         >
//                                                                             <option value="">All Projects</option>

//                                                                             {projects.map((project) => (
//                                                                                 <option key={project.id} value={project.id}>
//                                                                                     {project.name}
//                                                                                 </option>
//                                                                             ))}
//                                                                         </select>

//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </th>
//                                                         <th>Total Tax Amount</th>
//                                                         <th>Action</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {taxInvoices.length > 0 ? (
//                                                         taxInvoices.map((invoice, index) => (
//                                                             <tr key={invoice.id}>
//                                                                 <td>
//                                                                     <div className="form-check font-size-16">
//                                                                         <input
//                                                                             className="form-check-input"
//                                                                             type="checkbox"
//                                                                             id={`proformainvoiceCheck${index}`}
//                                                                         />
//                                                                         <label
//                                                                             className="form-check-label"
//                                                                             htmlFor={`proformainvoiceCheck${index}`}
//                                                                         ></label>
//                                                                     </div>
//                                                                 </td>
//                                                                 <td>{index + 1}</td>
//                                                                 <td><Link to={`/tax-invoice/details/${invoice.id}`} className="dropdown-item">{new Date(invoice.created_at).toLocaleDateString()}</Link></td>
//                                                                 <td><Link to={`/tax-invoice/details/${invoice.id}`} className="dropdown-item">{invoice.ref_no}</Link></td>
//                                                                 <td>{invoice?.proforma_invoice?.quotation?.project?.client?.name}</td>
//                                                                 <td>{invoice?.proforma_invoice?.quotation?.project?.name}</td>

//                                                                 <td>{invoice.total_with_vat}</td>
//                                                                 <td>
//                                                                     <div className="dropdown">
//                                                                         <i
//                                                                             className="mdi mdi-dots-horizontal font-size-18"
//                                                                             data-bs-toggle="dropdown"
//                                                                             aria-expanded="false"
//                                                                             style={{ cursor: 'pointer' }}
//                                                                         ></i>
//                                                                         <ul className="dropdown-menu dropdown-menu-end font-size-14">
//                                                                             <li>
//                                                                                 <Link to={`/tax-invoice/details/${invoice.id}`} className="dropdown-item">
//                                                                                     View Details
//                                                                                 </Link>
//                                                                             </li>

//                                                                             <li>
//                                                                                 <button
//                                                                                     className="dropdown-item"
//                                                                                     onClick={() => deleteTaxInvoice(invoice.id)}
//                                                                                 >
//                                                                                     Delete
//                                                                                 </button>
//                                                                             </li>
//                                                                         </ul>
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                         ))
//                                                     ) : (
//                                                         <tr><td colSpan="6" className="text-center">No tax invoices found.</td></tr>
//                                                     )}
//                                                 </tbody>

//                                             </table>
//                                             <div className="d-flex justify-content-end pagination-sm">
//                                                 <ReactPaginate
//                                                     previousLabel={'<'}
//                                                     nextLabel={'>'}
//                                                     breakLabel={'...'}
//                                                     pageCount={taxPagination.pageCount}
//                                                     marginPagesDisplayed={2}
//                                                     pageRangeDisplayed={3}
//                                                     onPageChange={handlePageClick1}
//                                                     containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                                                     pageClassName={'page-item'}
//                                                     pageLinkClassName={'page-link'}
//                                                     previousClassName={'page-item previous'}
//                                                     previousLinkClassName={'page-link'}
//                                                     nextClassName={'page-item next'}
//                                                     nextLinkClassName={'page-link'}
//                                                     breakClassName={'page-item'}
//                                                     breakLinkClassName={'page-link'}
//                                                     activeClassName={'active'}
//                                                 />
//                                             </div>
//                                         </div>
//                                     )}

//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>

//     );
// };



// export default InvoiceList;


import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { FaFilter, FaSearch, FaSync, FaFileInvoice, FaMoneyBillWave, FaCheckCircle, FaUndo, FaEye, FaTimes, FaClock, FaDownload, FaFileAlt, FaUpload, FaFileExcel, FaInfoCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';
import withPermission from '../../utils/withPermission';
import './InvoiceList.css';
import QuotationPreviewModal from '../quotation/QuotationPreviewModal';
import ProformaInvoicePreview from '../ProformaInvoice/ProformaInvoicePreview';
import { Button, Form, Row, Col, Modal, Offcanvas, Table, Card, Badge } from 'react-bootstrap';
import TaxInvoicePreview from '../ProformaInvoice/TaxInvoicePreview'; // Make sure this path is correct
import CreditNoteCreateOffcanvas from './CreditNoteCreateOffcanvas';
import CreditNotePreview from './CreditNotePreview'; // Adjust path as needed
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";

// Format number to US format with commas
const formatUSAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '0.00';

    const num = parseFloat(amount);
    if (isNaN(num)) return '0.00';

    return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

// Helper function to parse amounts safely
const parseAmount = (amount) => {
    if (amount === null || amount === undefined || amount === '') return 0;
    const parsed = parseFloat(amount);
    return isNaN(parsed) ? 0 : parsed;
};

// Helper function to calculate all invoice totals (amount, VAT, paid, balance)
const calculateInvoiceTotals = (invoice, type = 'proforma') => {
    // Determine invoice type
    let invoiceType = type;

    // Check for tax invoice indicators
    const isTaxInvoice =
        type === 'tax' ||
        invoice.tax_invoice_generated === true ||
        invoice.tax_invoice_generated === "1" ||
        invoice.tax_invoice_generated === 1 ||
        invoice.proforma_invoice ||
        (invoice.ref_no && (invoice.ref_no.includes('TI/') || invoice.ref_no.includes('/TI/')));

    if (isTaxInvoice) {
        invoiceType = 'tax';
    }

    // Get basic invoice amounts based on type
    let invoiceAmount = 0;
    let vatAmount = 0;
    let invoiceTotalWithVat = 0;
    let invoicePaidAmount = 0;

    if (invoiceType === 'proforma') {
        invoiceAmount = parseAmount(invoice.basic_amount || invoice.amount);
        vatAmount = parseAmount(invoice.vat_amount);
        invoiceTotalWithVat = parseAmount(invoice.total_with_vat || (invoiceAmount + vatAmount));
    } else {
        // For tax invoice - use appropriate fields
        invoiceAmount = parseAmount(invoice.basic_amount || invoice.amount || invoice.total_amount);
        vatAmount = parseAmount(invoice.vat_amount);
        invoiceTotalWithVat = parseAmount(invoice.total_with_vat || (invoiceAmount + vatAmount));
    }

    console.log('💰 Payment analysis for invoice:', invoice.ref_no, `(${invoiceType})`);
    console.log('   Invoice total with VAT:', invoiceTotalWithVat);

    // ========== SIMPLE PAYMENT CHECKING LOGIC ==========

    // Step 1: Check for payment records on the invoice itself
    if (invoice.transaction_invoice_items && Array.isArray(invoice.transaction_invoice_items)) {
        const itemsPaid = invoice.transaction_invoice_items.reduce(
            (sum, item) => sum + parseAmount(item.paid_amount), 0
        );
        if (itemsPaid > 0) {
            invoicePaidAmount = itemsPaid;
            console.log(`✅ Step 1: Found ${itemsPaid} from invoice's transaction_invoice_items`);
        }
    }

    // Step 2: Check pivot
    if (invoice.pivot && invoice.pivot.allocated_amount) {
        const pivotAmount = parseAmount(invoice.pivot.allocated_amount);
        if (pivotAmount > invoicePaidAmount) {
            invoicePaidAmount = pivotAmount;
            console.log(`✅ Step 2: Found ${pivotAmount} from invoice's pivot.allocated_amount`);
        }
    }

    // Step 3: Check transactions
    if (invoice.transactions && Array.isArray(invoice.transactions)) {
        const transactionPaidAmount = invoice.transactions.reduce(
            (sum, trans) => {
                if (trans.pivot && trans.pivot.allocated_amount) {
                    return sum + parseAmount(trans.pivot.allocated_amount);
                }
                return sum;
            }, 0
        );

        if (transactionPaidAmount > 0 && transactionPaidAmount > invoicePaidAmount) {
            invoicePaidAmount = transactionPaidAmount;
            console.log(`✅ Step 3: Found ${transactionPaidAmount} from invoice's transactions`);
        }
    }

    // ========== FOR TAX INVOICES: CHECK PROFORMA ==========
    if (invoiceType === 'tax' && invoice.proforma_invoice && invoicePaidAmount === 0) {
        const proforma = invoice.proforma_invoice;
        console.log(`🔍 Checking associated proforma invoice: ${proforma.ref_no}`);
        console.log(`   Proforma pi_status: ${proforma.pi_status}`);

        // IMPORTANT: Check if proforma has transaction_invoice_items
        // If not, the payment data is not included in the API response
        if (!proforma.transaction_invoice_items) {
            console.log(`❌ WARNING: Proforma invoice data does NOT include transaction_invoice_items!`);
            console.log(`   This is why tax invoices show as unpaid even when proforma is partially_paid.`);
            console.log(`   SOLUTION: Update the API to include proforma's payment data.`);
        }

        // Step 4: Check proforma's transaction_invoice_items
        if (proforma.transaction_invoice_items && Array.isArray(proforma.transaction_invoice_items)) {
            const proformaPaid = proforma.transaction_invoice_items.reduce(
                (sum, item) => {
                    const paid = parseAmount(item.paid_amount);
                    return sum + paid;
                }, 0
            );

            if (proformaPaid > 0) {
                invoicePaidAmount = proformaPaid;
                console.log(`✅ Step 4: Found ${proformaPaid} from proforma's transaction_invoice_items`);
            }
        }

        // Step 5: Check proforma's pivot
        if (invoicePaidAmount === 0 && proforma.pivot && proforma.pivot.allocated_amount) {
            const proformaPivotPaid = parseAmount(proforma.pivot.allocated_amount);
            invoicePaidAmount = proformaPivotPaid;
            console.log(`✅ Step 5: Found ${proformaPivotPaid} from proforma's pivot.allocated_amount`);
        }

        // Step 6: Check proforma's transactions
        if (invoicePaidAmount === 0 && proforma.transactions && Array.isArray(proforma.transactions)) {
            const proformaTransactionPaid = proforma.transactions.reduce(
                (sum, trans) => {
                    if (trans.pivot && trans.pivot.allocated_amount) {
                        return sum + parseAmount(trans.pivot.allocated_amount);
                    }
                    return sum;
                }, 0
            );

            if (proformaTransactionPaid > 0) {
                invoicePaidAmount = proformaTransactionPaid;
                console.log(`✅ Step 6: Found ${proformaTransactionPaid} from proforma's transactions`);
            }
        }

        // Step 7: Handle proforma payment status (ONLY if we found NO payment records)
        if (invoicePaidAmount === 0) {
            if (proforma.pi_status === 'payment_received') {
                // If proforma is marked as fully paid, tax invoice is also fully paid
                invoicePaidAmount = invoiceTotalWithVat;
                console.log(`✅ Step 7a: Marked as fully paid because proforma has payment_received status`);
            } else if (proforma.pi_status === 'partially_paid' || proforma.pi_status === 'partial') {
                // IMPORTANT: We know proforma is partially paid, but we don't know the amount
                // because payment records are not included in the API response
                console.log(`⚠️ Step 7b: Proforma is partially_paid but NO payment amount available`);
                console.log(`   Cannot determine partial payment amount without transaction_invoice_items`);
                // Leave as unpaid (invoicePaidAmount = 0)
            }
        }
    }

    // ========== FINAL CALCULATION ==========
    const invoiceBalance = parseFloat((invoiceTotalWithVat - invoicePaidAmount).toFixed(2));
    const isFullyPaid = Math.abs(invoiceBalance) < 0.01 || invoicePaidAmount >= invoiceTotalWithVat;

    console.log('📊 Final result for', invoice.ref_no, ':', {
        invoiceTotalWithVat,
        invoicePaidAmount,
        invoiceBalance,
        isFullyPaid,
        paymentStatus: isFullyPaid ? 'Paid' : invoicePaidAmount > 0 ? 'Partial' : 'Unpaid'
    });

    return {
        invoiceAmount,
        vatAmount,
        invoiceTotalWithVat,
        invoicePaidAmount,
        invoiceBalance,
        isFullyPaid,
        currency: invoice.currency || 'AED',
        pi_status: invoice.pi_status || invoice.proforma_invoice?.pi_status,
        invoiceType: invoiceType,
    };
};

const PaymentStatusBadge = ({ status, invoice }) => {
    // If invoice data is provided, calculate actual status
    if (invoice) {
        // Determine invoice type for calculation
        let invoiceType = 'proforma';

        // Check for tax invoice (without amount_received)
        const isTaxInvoice =
            invoice.tax_invoice_generated === true ||
            invoice.tax_invoice_generated === "1" ||
            invoice.tax_invoice_generated === 1 ||
            (invoice.ref_no && (invoice.ref_no.includes('TI/') || invoice.ref_no.includes('/TI/'))) ||
            invoice.proforma_invoice;

        if (isTaxInvoice) {
            invoiceType = 'tax';
        }

        console.log('🔍 PaymentStatusBadge - Analyzing:', {
            ref_no: invoice.ref_no,
            type: invoiceType,
            tax_invoice_generated: invoice.tax_invoice_generated,
            proforma_pi_status: invoice.proforma_invoice?.pi_status,
            has_proforma: !!invoice.proforma_invoice
        });

        const totals = calculateInvoiceTotals(invoice, invoiceType);

        // Return appropriate badge based on calculated amounts
        if (totals.isFullyPaid) {
            return (
                <span className="badge bg-success" title={`Paid: ${formatUSAmount(totals.invoicePaidAmount)} / Total: ${formatUSAmount(totals.invoiceTotalWithVat)}`}>
                    Paid
                </span>
            );
        } else if (totals.invoicePaidAmount > 0) {
            return (
                <span className="badge bg-info" title={`Paid: ${formatUSAmount(totals.invoicePaidAmount)} / Total: ${formatUSAmount(totals.invoiceTotalWithVat)}`}>
                    Partial
                </span>
            );
        } else {
            return (
                <span className="badge bg-warning" title={`Total: ${formatUSAmount(totals.invoiceTotalWithVat)}`}>
                    Unpaid
                </span>
            );
        }
    }

    // Fallback to simple status string if no invoice object provided
    switch (status) {
        case "paid":
        case "payment_received":
        case "completed":
            return <span className="badge bg-success">Paid</span>;
        case "PI_generated":
        case "pending":
        case "not_paid":
            return <span className="badge bg-warning">Unpaid</span>;
        case "partial":
        case "partially_paid":
            return <span className="badge bg-info">Partial</span>;
        case "cancelled":
        case "void":
            return <span className="badge bg-danger">Cancelled</span>;
        default:
            return <span className="badge bg-secondary">{status || 'Pending'}</span>;
    }
};

const InvoiceList = () => {
    // State management
    const [activeTab, setActiveTab] = useState("proforma");
    const [proformaInvoices, setProformaInvoices] = useState([]);
    const [taxInvoices, setTaxInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [projects, setProjects] = useState([]);
    const [clients, setClients] = useState([]);
    const [showQuotationModal, setShowQuotationModal] = useState(false);
    const [showProformaModal, setShowProformaModal] = useState(false);
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [selectedProformaInvoice, setSelectedProformaInvoice] = useState(null);
    const [customIntegration, setCustomIntegration] = useState('');
    const [editableDeploymentIntegration, setEditableDeploymentIntegration] = useState('');
    const [customIntegrationDescription, setCustomIntegrationDescription] = useState('');
    const [importLoading, setImportLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [selectedQuotationForUpload, setSelectedQuotationForUpload] = useState(null); // For upload
    const [uploadFile, setUploadFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [errors, setErrors] = useState({});
    // Add these state declarations near your other state declarations
    const [showCreditNoteOffcanvas, setShowCreditNoteOffcanvas] = useState(false);
    const [selectedInvoiceForCredit, setSelectedInvoiceForCredit] = useState(null);
    const [creditNoteType, setCreditNoteType] = useState('tax');

    const [showTaxInvoiceModal, setShowTaxInvoiceModal] = useState(false);
    const [selectedTaxInvoice, setSelectedTaxInvoice] = useState(null);
    const [selectedTaxQuotation, setSelectedTaxQuotation] = useState(null);
    // Add these state declarations near your other state declarations
    const [showDetailsOffcanvas, setShowDetailsOffcanvas] = useState(false);
    const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);
    const [invoicePaymentHistory, setInvoicePaymentHistory] = useState([]);
    // Pagination states
    const [proformaPagination, setProformaPagination] = useState({
        currentPage: 1,
        pageCount: 0,
        total: 0
    });

    const [taxPagination, setTaxPagination] = useState({
        currentPage: 1,
        pageCount: 0,
        total: 0
    });
    const [filteredSummary, setFilteredSummary] = useState({
        totalAmount: 0,
        totalVat: 0,
        totalWithVat: 0,
        totalPaid: 0,
        totalUnpaid: 0,
        totalPartial: 0
    });
    const [creditNotesPagination, setCreditNotesPagination] = useState({
        currentPage: 1,
        pageCount: 0,
        total: 0
    });
    const [showCreditNotePreview, setShowCreditNotePreview] = useState(false);
    const [creditNotes, setCreditNotes] = useState([]);
    // Add these state variables near your other state declarations
    const [summaryTotals, setSummaryTotals] = useState({
        totalAmount: 0,
        totalVat: 0,
        totalWithVat: 0,
        totalPaid: 0,
        totalUnpaid: 0,
        totalPartial: 0
    });


    // Add this function to calculate summary totals
    const calculateSummaryTotals = () => {
        if (activeTab === "proforma") {
            return calculateProformaSummary();
        } else if (activeTab === "tax") {
            return calculateTaxSummary();
        } else if (activeTab === "credit-notes") {
            return calculateCreditNotesSummary();
        }
        return {
            totalAmount: 0,
            totalVat: 0,
            totalWithVat: 0,
            totalPaid: 0,
            totalUnpaid: 0,
            totalPartial: 0
        };
    };

    // Add this function to calculate proforma invoice summary
    const calculateProformaSummary = () => {
        let totalAmount = 0;
        let totalVat = 0;
        let totalWithVat = 0;
        let totalPaid = 0;
        let totalUnpaid = 0;
        let totalPartial = 0;

        proformaInvoices.forEach(invoice => {
            const totals = calculateInvoiceTotals(invoice, 'proforma');

            totalAmount += totals.invoiceAmount;
            totalVat += totals.vatAmount;
            totalWithVat += totals.invoiceTotalWithVat;

            if (totals.isFullyPaid) {
                totalPaid += totals.invoiceTotalWithVat;
            } else if (totals.invoicePaidAmount > 0) {
                totalPartial += totals.invoiceTotalWithVat;
            } else {
                totalUnpaid += totals.invoiceTotalWithVat;
            }
        });

        return {
            totalAmount,
            totalVat,
            totalWithVat,
            totalPaid,
            totalUnpaid,
            totalPartial
        };
    };

    // Add this function to calculate tax invoice summary
    const calculateTaxSummary = () => {
        let totalAmount = 0;
        let totalVat = 0;
        let totalWithVat = 0;
        let totalPaid = 0;
        let totalUnpaid = 0;
        let totalPartial = 0;

        taxInvoices.forEach(invoice => {
            const totals = calculateInvoiceTotals(invoice, 'tax');

            totalAmount += totals.invoiceAmount;
            totalVat += totals.vatAmount;
            totalWithVat += totals.invoiceTotalWithVat;

            if (totals.isFullyPaid) {
                totalPaid += totals.invoiceTotalWithVat;
            } else if (totals.invoicePaidAmount > 0) {
                totalPartial += totals.invoiceTotalWithVat;
            } else {
                totalUnpaid += totals.invoiceTotalWithVat;
            }
        });

        return {
            totalAmount,
            totalVat,
            totalWithVat,
            totalPaid,
            totalUnpaid,
            totalPartial
        };
    };

    // Add this function to calculate credit notes summary
    const calculateCreditNotesSummary = () => {
        let totalAmount = 0;
        let totalApproved = 0;
        let totalPending = 0;
        let totalCancelled = 0;

        creditNotes.forEach(note => {
            const amount = parseFloat(note.total_amount) || 0;
            totalAmount += amount;

            if (note.status === 'approved') {
                totalApproved += amount;
            } else if (note.status === 'pending') {
                totalPending += amount;
            } else if (note.status === 'cancelled') {
                totalCancelled += amount;
            }
        });

        return {
            totalAmount,
            totalApproved,
            totalPending,
            totalCancelled
        };
    };

    // Add comprehensive calculation functions for each tab
    const calculateProformaTableTotals = () => {
        let amountSum = 0;
        let advancedAmountSum = 0;
        let paidAmountSum = 0;
        let balanceSum = 0;

        proformaInvoices.forEach(invoice => {
            const totals = calculateInvoiceTotals(invoice, 'proforma');
            amountSum += totals.invoiceTotalWithVat;
            advancedAmountSum += parseFloat(invoice.advanced_amount) || 0;
            paidAmountSum += totals.invoicePaidAmount;
            balanceSum += totals.invoiceBalance;
        });

        return {
            amountSum,
            advancedAmountSum,
            paidAmountSum,
            balanceSum,
            count: proformaInvoices.length
        };
    };

    const calculateTaxTableTotals = () => {
        let basicAmountSum = 0;
        let vatAmountSum = 0;
        let totalWithVatSum = 0;
        let paidAmountSum = 0;
        let balanceSum = 0;

        taxInvoices.forEach(invoice => {
            const totals = calculateInvoiceTotals(invoice, 'tax');
            basicAmountSum += totals.invoiceAmount;
            vatAmountSum += totals.vatAmount;
            totalWithVatSum += totals.invoiceTotalWithVat;
            paidAmountSum += totals.invoicePaidAmount;
            balanceSum += totals.invoiceBalance;
        });

        return {
            basicAmountSum,
            vatAmountSum,
            totalWithVatSum,
            paidAmountSum,
            balanceSum,
            count: taxInvoices.length
        };
    };

    const calculateCreditNotesTableTotals = () => {
        let amountSum = 0;
        let approvedSum = 0;
        let pendingSum = 0;
        let cancelledSum = 0;

        creditNotes.forEach(note => {
            const amount = parseFloat(note.total_amount) || 0;
            amountSum += amount;

            if (note.status === 'approved') {
                approvedSum += amount;
            } else if (note.status === 'pending') {
                pendingSum += amount;
            } else if (note.status === 'cancelled') {
                cancelledSum += amount;
            }
        });

        return {
            amountSum,
            approvedSum,
            pendingSum,
            cancelledSum,
            count: creditNotes.length
        };
    };
    const [selectedCreditNote, setSelectedCreditNote] = useState(null);

    // Add credit notes filter state
    const [creditNoteFilters, setCreditNoteFilters] = useState({
        dateRange: { from: '', to: '' },
        status: 'all',
        clientId: '',
        searchQuery: ''
    });
    const [hasFiltersApplied, setHasFiltersApplied] = useState(false);
    const [isCalculatingSummary, setIsCalculatingSummary] = useState(false);
    const calculateEstimatedSummary = () => {
        if (activeTab === "proforma") {
            if (proformaInvoices.length === 0) return {
                totalAmount: 0, totalVat: 0, totalWithVat: 0,
                totalPaid: 0, totalUnpaid: 0, totalPartial: 0
            };

            // Calculate averages from current page
            const pageTotals = calculateProformaSummary();
            const pageCount = proformaInvoices.length;
            const totalCount = proformaPagination.total;

            // Calculate averages
            const avgAmountPerInvoice = pageTotals.totalAmount / pageCount;
            const avgVatPerInvoice = pageTotals.totalVat / pageCount;
            const avgWithVatPerInvoice = pageTotals.totalWithVat / pageCount;
            const avgPaidPerInvoice = pageTotals.totalPaid / pageCount;
            const avgUnpaidPerInvoice = pageTotals.totalUnpaid / pageCount;
            const avgPartialPerInvoice = pageTotals.totalPartial / pageCount;

            // Estimate totals for all filtered invoices
            return {
                totalAmount: avgAmountPerInvoice * totalCount,
                totalVat: avgVatPerInvoice * totalCount,
                totalWithVat: avgWithVatPerInvoice * totalCount,
                totalPaid: avgPaidPerInvoice * totalCount,
                totalUnpaid: avgUnpaidPerInvoice * totalCount,
                totalPartial: avgPartialPerInvoice * totalCount
            };

        } else if (activeTab === "tax") {
            if (taxInvoices.length === 0) return {
                totalAmount: 0, totalVat: 0, totalWithVat: 0,
                totalPaid: 0, totalUnpaid: 0, totalPartial: 0
            };

            // Calculate averages from current page
            const pageTotals = calculateTaxSummary();
            const pageCount = taxInvoices.length;
            const totalCount = taxPagination.total;

            // Calculate averages
            const avgAmountPerInvoice = pageTotals.totalAmount / pageCount;
            const avgVatPerInvoice = pageTotals.totalVat / pageCount;
            const avgWithVatPerInvoice = pageTotals.totalWithVat / pageCount;
            const avgPaidPerInvoice = pageTotals.totalPaid / pageCount;
            const avgUnpaidPerInvoice = pageTotals.totalUnpaid / pageCount;
            const avgPartialPerInvoice = pageTotals.totalPartial / pageCount;

            // Estimate totals for all filtered invoices
            return {
                totalAmount: avgAmountPerInvoice * totalCount,
                totalVat: avgVatPerInvoice * totalCount,
                totalWithVat: avgWithVatPerInvoice * totalCount,
                totalPaid: avgPaidPerInvoice * totalCount,
                totalUnpaid: avgUnpaidPerInvoice * totalCount,
                totalPartial: avgPartialPerInvoice * totalCount
            };

        } else if (activeTab === "credit-notes") {
            const summary = calculateCreditNotesSummary();
            return {
                ...summary,
                totalVat: 0,
                totalWithVat: 0,
                totalPaid: 0,
                totalUnpaid: 0,
                totalPartial: 0
            };
        }

        return {
            totalAmount: 0, totalVat: 0, totalWithVat: 0,
            totalPaid: 0, totalUnpaid: 0, totalPartial: 0
        };
    };

    // Modify applyFilters to calculate estimated summary
    const applyFilters = () => {
        setIsCalculatingSummary(true);

        if (hasFiltersApplied) {
            // If filters were already applied, subsequent clicks fetch directly
            if (activeTab === "proforma") {
                fetchProformaInvoices(1, true);
            } else if (activeTab === "tax") {
                fetchTaxInvoices(1, true);
            } else if (activeTab === "credit-notes") {
                fetchCreditNotes(1, true);
            }
        } else {
            // First time filter application triggers the useEffect via state change
            setHasFiltersApplied(true);
        }
    };

    // Update summary when data loads
    // Removed client-side summary calculation effect to rely on backend totals
    // useEffect(() => {
    //     if (hasFiltersApplied && (proformaInvoices.length > 0 || taxInvoices.length > 0 || creditNotes.length > 0)) {
    //         const estimatedSummary = calculateEstimatedSummary();
    //         setFilteredSummary(estimatedSummary);
    //         setIsCalculatingSummary(false);
    //     }
    // }, [proformaInvoices, taxInvoices, creditNotes, hasFiltersApplied]);


    // Modify resetFilters
    const resetFilters = () => {
        setHasFiltersApplied(false);
        setIsCalculatingSummary(false);
        setFilteredSummary({
            totalAmount: 0, totalVat: 0, totalWithVat: 0,
            totalPaid: 0, totalUnpaid: 0, totalPartial: 0
        });

        if (activeTab === "proforma") {
            setFilters({
                dateRange: { from: '', to: '' },
                datePreset: '',
                paymentStatus: 'all',
                workStatus: 'all',
                taxInvoiceStatus: 'all',
                projectId: '',
                clientId: '',
                searchQuery: ''
            });
            setProformaInvoices([]);
            setProformaPagination({ currentPage: 1, pageCount: 0, total: 0 });
        } else if (activeTab === "tax") {
            setFilters({
                dateRange: { from: '', to: '' },
                datePreset: '',
                taxInvoiceStatus: 'all',
                projectId: '',
                clientId: '',
                searchQuery: '',
                documentStatus: 'all'
            });
            setTaxInvoices([]);
            setTaxPagination({ currentPage: 1, pageCount: 0, total: 0 });
        } else if (activeTab === "credit-notes") {
            setCreditNoteFilters({
                dateRange: { from: '', to: '' },
                status: 'all',
                clientId: '',
                searchQuery: ''
            });
            setCreditNotes([]);
            setCreditNotesPagination({ currentPage: 1, pageCount: 0, total: 0 });
        }
    };

    // Modify tab change handler
    useEffect(() => {
        if (!hasFiltersApplied) {
            // Clear data when switching tabs without filters
            setProformaInvoices([]);
            setTaxInvoices([]);
            setCreditNotes([]);
            setFilteredSummary({
                totalAmount: 0, totalVat: 0, totalWithVat: 0,
                totalPaid: 0, totalUnpaid: 0, totalPartial: 0
            });
            return;
        }

        // If filters are applied, load data for new tab
        if (activeTab === "proforma") {
            fetchProformaInvoices(1, true);
        } else if (activeTab === "tax") {
            fetchTaxInvoices(1, true);
        } else if (activeTab === "credit-notes") {
            fetchCreditNotes(1, true);
        }
    }, [activeTab, hasFiltersApplied]);

    // Update your table footer calculations
    const getTableFooterTotals = () => {
        if (!hasFiltersApplied) {
            return {
                amount: '0.00',
                vat: '0.00',
                withVat: '0.00'
            };
        }

        if (activeTab === "proforma") {
            const tableTotals = calculateProformaTableTotals();
            return {
                amount: formatUSAmount(tableTotals.amountSum),
                vat: formatUSAmount(0), // Proforma might not have VAT shown separately
                withVat: formatUSAmount(tableTotals.amountSum) // Assuming amount includes VAT
            };
        } else if (activeTab === "tax") {
            const tableTotals = calculateTaxTableTotals();
            return {
                amount: formatUSAmount(tableTotals.basicAmountSum),
                vat: formatUSAmount(tableTotals.vatAmountSum),
                withVat: formatUSAmount(tableTotals.totalWithVatSum)
            };
        }

        return { amount: '0.00', vat: '0.00', withVat: '0.00' };
    };

    // In your JSX, update the summary display
    const tableFooterTotals = getTableFooterTotals();

    // Comprehensive filter state
    const [filters, setFilters] = useState({
        // Date filters
        dateRange: { from: '', to: '' },
        datePreset: '', // today, yesterday, this_week, last_week, this_month, last_month

        // Status filters
        paymentStatus: 'all', // all, paid, unpaid, partial
        workStatus: 'all', // all, completed, pending, in_progress
        taxInvoiceStatus: 'all', // all, generated, not_generated

        // Selection filters
        projectId: '',
        clientId: '',
        searchQuery: '',
        documentStatus: 'all', // all, uploaded, pending
    });

    // Permission hooks
    const WithCreatePermission = withPermission(({ children }) => children, ['proformainvoice-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['proformainvoice-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['proformainvoice-delete']);

    // Filter handlers
    const updateFilter = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };



    const handleDatePresetChange = (preset) => {
        const today = new Date();
        let fromDate = '';
        let toDate = '';

        switch (preset) {
            case 'today':
                fromDate = today.toISOString().split('T')[0];
                toDate = fromDate;
                break;
            case 'yesterday':
                const yesterday = new Date(today);
                yesterday.setDate(yesterday.getDate() - 1);
                fromDate = yesterday.toISOString().split('T')[0];
                toDate = fromDate;
                break;
            case 'this_week':
                const startOfWeek = new Date(today);
                startOfWeek.setDate(today.getDate() - today.getDay());
                fromDate = startOfWeek.toISOString().split('T')[0];
                toDate = today.toISOString().split('T')[0];
                break;
            case 'last_week':
                const startOfLastWeek = new Date(today);
                startOfLastWeek.setDate(today.getDate() - today.getDay() - 7);
                const endOfLastWeek = new Date(startOfLastWeek);
                endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
                fromDate = startOfLastWeek.toISOString().split('T')[0];
                toDate = endOfLastWeek.toISOString().split('T')[0];
                break;
            case 'this_month':
                fromDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
                toDate = today.toISOString().split('T')[0];
                break;
            case 'last_month':
                const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                fromDate = firstDayLastMonth.toISOString().split('T')[0];
                toDate = lastDayLastMonth.toISOString().split('T')[0];
                break;
            default:
                break;
        }

        setFilters(prev => ({
            ...prev,
            datePreset: preset,
            dateRange: { from: fromDate, to: toDate }
        }));
    };








    // Add this function to format summary numbers
    const formatSummaryNumber = (num) => {
        return formatUSAmount(Math.abs(num));
    };
    // Data fetching functions
    const fetchProjects = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/projects`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setProjects(response.data.Data || []);
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };

    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=client`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setClients(response.data.Data || []);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    const sortInvoicesByRefNo = (invoices, order = 'asc') => {
        return [...invoices].sort((a, b) => {
            // Extract numbers from ref_no (assuming format like "PI-001", "PI-002", etc.)
            const getRefNumber = (ref) => {
                const match = ref?.match(/\d+/);
                return match ? parseInt(match[0]) : 0;
            };

            const aNum = getRefNumber(a.ref_no);
            const bNum = getRefNumber(b.ref_no);

            if (order === 'asc') {
                return aNum - bNum; // 1, 2, 3, ...
            } else {
                return bNum - aNum; // 3, 2, 1, ...
            }
        });
    };
    const hasCreditNote = (invoice) => {
        if (!invoice) return false;
        if (invoice.credit_note_id) return true;
        if (invoice.credit_note) return true;
        if (Array.isArray(invoice.credit_notes) && invoice.credit_notes.length > 0) return true;
        if (invoice.status === 'fully_credited') return true;
        return false;
    };

    const fetchProformaInvoices = async (page = 1, applyFilters = true) => {
        try {
            setLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Build params
            let params = { page };

            if (applyFilters) {
                if (filters.dateRange.from) params.from_date = filters.dateRange.from;
                if (filters.dateRange.to) params.to_date = filters.dateRange.to;
                if (filters.paymentStatus !== 'all') params.payment_status = filters.paymentStatus;
                if (filters.workStatus !== 'all') params.work_status = filters.workStatus;
                if (filters.projectId) params.project_id = filters.projectId;
                if (filters.clientId) params.client_id = filters.clientId;
                if (filters.searchQuery) params.search = filters.searchQuery;
                if (filters.taxInvoiceStatus !== 'all') params.tax_invoice_status = filters.taxInvoiceStatus;
            }

            const response = await axios.get(`${backendUrl}/api/proformainvoice`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params
            });

            const proformaInvoiceData = response.data.proformainvoice || {};
            let invoices = proformaInvoiceData.data || [];
            // invoices = invoices.filter(invoice => !hasCreditNote(invoice));
            // invoices = sortInvoicesByRefNo(invoices, 'asc');


            setProformaInvoices(invoices);
            setProformaPagination({
                currentPage: proformaInvoiceData.current_page || 1,
                pageCount: proformaInvoiceData.last_page || 1,
                total: proformaInvoiceData.total || 0
            });

            // Set summary totals from backend
            const totalWithVat = response.data.total_with_vat || response.data.total_received || 0;
            const totalPaid = response.data.total_received || 0;
            const totalUnpaid = totalWithVat - totalPaid;

            setSummaryTotals({
                totalAmount: response.data.total_amount || 0,
                totalVat: response.data.total_vat || 0,
                totalWithVat: totalWithVat,
                totalPaid: totalPaid,
                totalUnpaid: totalUnpaid > 0 ? totalUnpaid : 0,
                totalPartial: 0 // Backend doesn't distinguish partial in sum yet
            });

        } catch (error) {
            console.error("Error fetching proforma invoices:", error);
            Swal.fire("Error!", "Failed to load proforma invoices.", "error");
        } finally {
            setLoading(false);
        }
    };

    const fetchTaxInvoices = async (page = 1, applyFilters = true) => {
        try {
            setLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = { page };

            if (applyFilters) {
                if (filters.dateRange.from) params.from_date = filters.dateRange.from;
                if (filters.dateRange.to) params.to_date = filters.dateRange.to;
                if (filters.taxInvoiceStatus !== 'all') params.tax_invoice_status = filters.taxInvoiceStatus;
                if (filters.projectId) params.project_id = filters.projectId;
                if (filters.clientId) params.client_id = filters.clientId;
                if (filters.searchQuery) params.search = filters.searchQuery;
                if (filters.documentStatus !== 'all') params.document_status = filters.documentStatus;
            }

            const response = await axios.get(`${backendUrl}/api/taxinvoices`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params
            });

            if (response.data.status === "success") {
                // const taxInvoicesList = response.data.taxinvoices?.data || [];
                let taxInvoicesList = response.data.taxinvoices?.data || [];
                // taxInvoicesList = taxInvoicesList.filter(invoice => !hasCreditNote(invoice));

                // Sort tax invoices by ref_no in ascending order
                taxInvoicesList = sortInvoicesByRefNo(taxInvoicesList, 'asc');

                setTaxInvoices(taxInvoicesList);
                setTaxPagination({
                    currentPage: response.data.taxinvoices?.current_page || 1,
                    pageCount: response.data.taxinvoices?.last_page || 1,
                    total: response.data.taxinvoices?.total || 0
                });

                // Set summary totals from backend
                const totalWithVat = response.data.total_with_vat || 0;
                const totalPaid = response.data.total_received || 0;
                const totalUnpaid = totalWithVat - totalPaid;

                setSummaryTotals({
                    totalAmount: response.data.total_amount || 0,
                    totalVat: response.data.total_vat || 0,
                    totalWithVat: totalWithVat,
                    totalPaid: totalPaid,
                    totalUnpaid: totalUnpaid > 0 ? totalUnpaid : 0,
                    totalPartial: 0
                });
            }

        } catch (error) {
            console.error("Error fetching tax invoices:", error);
            Swal.fire("Error!", "Failed to load tax invoices.", "error");
        } finally {
            setLoading(false);
        }
    };


    const handleCreateCreditNote = (invoice, type = 'proforma') => {
        const isDraft = invoice.status === 'draft';
        const isFullyCredited = invoice.status === 'fully_credited';

        const hasTaxInvoice =
            type === 'proforma'
                ? invoice.tax_invoice_generated === 1 ||
                invoice.tax_invoice_generated === '1'
                : true; // tax invoice itself

        if (isDraft || isFullyCredited || !hasTaxInvoice) {
            Swal.fire({
                icon: 'warning',
                title: 'Cannot Create Credit Note',
                text: isDraft
                    ? 'Invoice is still in draft status.'
                    : isFullyCredited
                        ? 'Invoice has already been fully credited.'
                        : 'Tax invoice not generated yet.',
                timer: 3000,
                showConfirmButton: false
            });
            return;
        }

        setSelectedInvoiceForCredit(invoice);
        setCreditNoteType(type);
        setShowCreditNoteOffcanvas(true);
    };

    const handleCreditNoteCreated = () => {
        // Refresh the appropriate invoice list
        if (activeTab === "proforma") {
            fetchProformaInvoices(proformaPagination.currentPage, true);
        } else {
            fetchTaxInvoices(taxPagination.currentPage, true);
        }

        // Show success message
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Credit note created successfully!',
            timer: 3000,
            showConfirmButton: false
        });
    };

    // Apply filters handler
    // const applyFilters = () => {
    //     if (activeTab === "proforma") {
    //         fetchProformaInvoices(1, true);
    //     } else if (activeTab === "tax") {
    //         fetchTaxInvoices(1, true);
    //     } else if (activeTab === "credit-notes") {
    //         fetchCreditNotes(1, true);
    //     }
    // };

    // Pagination handlers
    const handleProformaPageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchProformaInvoices(selectedPage);
    };

    const handleTaxPageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchTaxInvoices(selectedPage, true);
    };
    // Add these functions to handle tax invoice actions
    const handleTaxInvoiceClick = async (invoice) => {
        try {
            console.log('Selected Tax Invoice:', invoice);

            // Fetch full tax invoice details if needed
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const taxInvoiceResponse = await axios.get(
                `${backendUrl}/api/taxinvoice/${invoice.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    skipLoader: true,
                }
            );

            const fullTaxInvoice = taxInvoiceResponse.data.taxinvoice || taxInvoiceResponse.data.data;

            // Process quotation data for the tax invoice
            const processedQuotationData = fullTaxInvoice.proforma_invoice?.quotation ? {
                ...fullTaxInvoice.proforma_invoice.quotation,
                revenueSplit: splitOrderByRevenueType(fullTaxInvoice.proforma_invoice.quotation)
            } : null;

            setSelectedTaxInvoice(fullTaxInvoice);
            setSelectedTaxQuotation(processedQuotationData);
            setShowTaxInvoiceModal(true);

        } catch (error) {
            console.error('Error fetching tax invoice details:', error);
            // Fallback to basic data
            const processedQuotationData = invoice.proforma_invoice?.quotation ? {
                ...invoice.proforma_invoice.quotation,
                revenueSplit: { subscription: { items: [], total: 0, count: 0 }, deployment: { items: [], total: 0, count: 0 } }
            } : null;

            setSelectedTaxInvoice(invoice);
            setSelectedTaxQuotation(processedQuotationData);
            setShowTaxInvoiceModal(true);
        }
    };

    // Update the handleViewDetails function to use existing data
    // const handleViewDetails = async (invoice, type = 'proforma') => {
    //     try {
    //         setSelectedInvoiceDetails(invoice);

    //         // Extract payment history from transaction data
    //         let paymentHistory = [];

    //         if (type === 'proforma') {
    //             // If we have transaction data in proforma invoice
    //             if (invoice.transaction) {
    //                 paymentHistory = [{
    //                     id: invoice.transaction.id,
    //                     payment_date: invoice.transaction.date,
    //                     reference_no: invoice.transaction.reference_no,
    //                     amount: invoice.transaction.amount,
    //                     payment_method: invoice.transaction.account?.type || 'N/A',
    //                     status: 'completed'
    //                 }];

    //                 // Check if there are more transactions in transaction array
    //                 if (invoice.transactions && Array.isArray(invoice.transactions)) {
    //                     invoice.transactions.forEach(transaction => {
    //                         if (transaction.id !== invoice.transaction?.id) {
    //                             paymentHistory.push({
    //                                 id: transaction.id,
    //                                 payment_date: transaction.date,
    //                                 reference_no: transaction.reference_no,
    //                                 amount: transaction.amount,
    //                                 payment_method: transaction.account?.type || 'N/A',
    //                                 status: 'completed'
    //                             });
    //                         }
    //                     });
    //                 }
    //             }
    //         } else {
    //             // For tax invoice, check if it has proforma_invoice with transaction
    //             if (invoice.proforma_invoice?.transaction) {
    //                 paymentHistory = [{
    //                     id: invoice.proforma_invoice.transaction.id,
    //                     payment_date: invoice.proforma_invoice.transaction.date,
    //                     reference_no: invoice.proforma_invoice.transaction.reference_no,
    //                     amount: invoice.proforma_invoice.transaction.amount,
    //                     payment_method: invoice.proforma_invoice.transaction.account?.type || 'N/A',
    //                     status: 'completed'
    //                 }];
    //             }
    //         }

    //         setInvoicePaymentHistory(paymentHistory);
    //         setShowDetailsOffcanvas(true);

    //     } catch (error) {
    //         console.error("Error processing invoice details:", error);
    //         // Still show the offcanvas with basic info
    //         setShowDetailsOffcanvas(true);
    //     }
    // };

    // const handleViewDetails = async (invoice, type = 'proforma') => {
    //     try {
    //         console.log('👁️ View Details - Original Invoice Data:', invoice);

    //         // Extract payment data from various sources
    //         let paymentHistory = [];
    //         let transactionInvoiceItems = [];

    //         // Check for pivot data (from transaction-invoice relationship)
    //         if (invoice.pivot && invoice.pivot.allocated_amount) {
    //             console.log('📌 Found pivot data:', invoice.pivot);

    //             // Create a transaction invoice item from pivot data
    //             transactionInvoiceItems = [{
    //                 id: `pivot-${invoice.id}`,
    //                 paid_amount: invoice.pivot.allocated_amount,
    //                 balance_amount: invoice.total_with_vat ?
    //                     (parseFloat(invoice.total_with_vat) - parseFloat(invoice.pivot.allocated_amount)) :
    //                     ((parseFloat(invoice.basic_amount || invoice.amount || 0) + parseFloat(invoice.vat_amount || 0)) - parseFloat(invoice.pivot.allocated_amount)),
    //                 is_fully_paid: parseFloat(invoice.pivot.allocated_amount) >=
    //                     (parseFloat(invoice.total_with_vat) ||
    //                         (parseFloat(invoice.basic_amount || invoice.amount || 0) + parseFloat(invoice.vat_amount || 0)))
    //             }];
    //         }

    //         // Check for transaction_invoice_items directly on invoice
    //         if (invoice.transaction_invoice_items && Array.isArray(invoice.transaction_invoice_items)) {
    //             console.log('📌 Found transaction_invoice_items on invoice:', invoice.transaction_invoice_items);
    //             transactionInvoiceItems = invoice.transaction_invoice_items;
    //         }

    //         // If invoice has transaction data, extract payment history
    //         // if (invoice.transaction) {
    //         //     console.log('📌 Found transaction data:', invoice.transaction);
    //         //     paymentHistory = [{
    //         //         id: invoice.transaction.id,
    //         //         payment_date: invoice.transaction.date || invoice.transaction.created_at,
    //         //         reference_no: invoice.transaction.reference_no || `TR-${invoice.transaction.id}`,
    //         //         amount: invoice.transaction.amount,
    //         //         payment_method: invoice.transaction.account?.type || invoice.transaction.payment_mode || 'N/A',
    //         //         status: 'completed',
    //         //          account_details: transaction.account ? {
    //         //                 account_name: transaction.account.name,
    //         //                 account_number: transaction.account.account_number,
    //         //                 bank_name: transaction.account.branch_name
    //         //             } : null
    //         //     }];

    //         //     // Also check for transaction_invoice_items in the transaction object
    //         //     if (invoice.transaction.transaction_invoice_items && 
    //         //         Array.isArray(invoice.transaction.transaction_invoice_items)) {
    //         //         console.log('📌 Found transaction_invoice_items in transaction:', invoice.transaction.transaction_invoice_items);
    //         //         transactionInvoiceItems = invoice.transaction.transaction_invoice_items;
    //         //     }
    //         // }

    //         if (invoice.transactions && Array.isArray(invoice.transactions)) {
    //             console.log('📌 Found transactions array:', invoice.transactions);

    //             invoice.transactions.forEach(transaction => {
    //                 // Extract payment information from each transaction
    //                 paymentHistory.push({
    //                     id: transaction.id,
    //                     payment_date: transaction.date || transaction.created_at,
    //                     reference_no: transaction.reference_no || `TR-${transaction.id}`,
    //                     amount: transaction.amount,
    //                     payment_method: transaction.account?.type || transaction.account_type || transaction.payment_mode || 'Bank Transfer',

    //                     status: transaction.reconciliation_status === 'reconciled' ? 'Completed' : 'Pending',
    //                     account_details: transaction.account ? {
    //                         account_name: transaction.account.name,
    //                         account_number: transaction.account.account_number,
    //                         bank_name: transaction.account.branch_name
    //                     } : null
    //                 });

    //                 // Also check for transaction_invoice_items in the transaction object
    //                 if (transaction.transaction_invoice_items &&
    //                     Array.isArray(transaction.transaction_invoice_items)) {
    //                     console.log('📌 Found transaction_invoice_items in transaction:', transaction.transaction_invoice_items);
    //                     transactionInvoiceItems = [...transactionInvoiceItems, ...transaction.transaction_invoice_items];
    //                 }
    //             });
    //         }

    //         // Create enhanced invoice data with payment information
    //         const invoiceWithPaymentData = {
    //             ...invoice,
    //             // Include transaction_invoice_items if we found any
    //             ...(transactionInvoiceItems.length > 0 && {
    //                 transaction_invoice_items: transactionInvoiceItems
    //             }),
    //             // Also include pivot data if it exists
    //             ...(invoice.pivot && { pivot: invoice.pivot }),
    //             invoiceType: type

    //         };

    //         console.log('✅ Enhanced Invoice Data for Offcanvas:', invoiceWithPaymentData);

    //         setSelectedInvoiceDetails(invoiceWithPaymentData);
    //         setInvoicePaymentHistory(paymentHistory);
    //         setShowDetailsOffcanvas(true);

    //     } catch (error) {
    //         console.error("❌ Error processing invoice details:", error);
    //         // Still show the offcanvas with basic info
    //         setSelectedInvoiceDetails(invoice);
    //         setShowDetailsOffcanvas(true);
    //     }
    // };

    const handleViewDetails = async (invoice, type = 'proforma') => {

        try {
            let invoiceType = type;

            // If type is 'tax' or invoice has tax invoice properties
            if (type === 'tax' || invoice.tax_invoice_generated === true ||
                invoice.tax_invoice_generated === 1 || invoice.proforma_invoice) {
                invoiceType = 'tax';
            }
            console.log('👁️ View Details - Invoice Data:', {
                id: invoice.id,
                ref_no: invoice.ref_no,
                pivot: invoice.pivot,
                transactions: invoice.transactions,
                transaction_invoice_items: invoice.transaction_invoice_items
            });

            let paymentHistory = [];
            let transactionInvoiceItems = [];
            let transactionAllocations = [];

            // Process pivot data from transaction relationships
            if (invoice.pivot && invoice.pivot.allocated_amount) {
                console.log('📌 Processing pivot data:', invoice.pivot);

                // Create transaction invoice item from pivot
                transactionInvoiceItems.push({
                    id: `pivot-${invoice.id}`,
                    paid_amount: invoice.pivot.allocated_amount,
                    balance_amount: parseAmount(invoice.total_with_vat) - parseAmount(invoice.pivot.allocated_amount),
                    is_fully_paid: parseAmount(invoice.pivot.allocated_amount) >= parseAmount(invoice.total_with_vat)
                });
            }

            // Process transactions array with detailed allocation
            if (invoice.transactions && Array.isArray(invoice.transactions)) {
                console.log('📌 Processing transactions array:', invoice.transactions.length);

                invoice.transactions.forEach(transaction => {
                    // Store transaction allocation details
                    const transactionData = {
                        id: transaction.id,
                        date: transaction.date || transaction.created_at,
                        reference_no: transaction.reference_no || `TR-${transaction.id}`,
                        total_amount: transaction.amount,
                        payment_method: transaction.account?.type || transaction.payment_mode || 'Bank Transfer',
                        status: transaction.reconciliation_status === 'reconciled' ? 'Completed' : 'Pending',
                        account_details: transaction.account ? {
                            account_name: transaction.account.name,
                            account_number: transaction.account.account_number,
                            bank_name: transaction.account.branch_name
                        } : null,
                        allocated_to_invoices: []
                    };

                    // Check if transaction has pivot with allocated amount for THIS invoice
                    if (transaction.pivot && transaction.pivot.allocated_amount) {
                        const allocatedAmount = parseAmount(transaction.pivot.allocated_amount);
                        transactionData.allocated_to_invoices.push({
                            invoice_ref: invoice.ref_no,
                            allocated_amount: allocatedAmount,
                            percentage: (allocatedAmount / parseAmount(transaction.amount)) * 100
                        });

                        paymentHistory.push({
                            ...transactionData,
                            amount: allocatedAmount, // Show allocated amount, not total
                            original_amount: transaction.amount,
                            note: `Allocated ${formatUSAmount(allocatedAmount)} from total ${formatUSAmount(transaction.amount)}`
                        });
                    }

                    // Check if transaction has transaction_invoice_items
                    if (transaction.transaction_invoice_items && Array.isArray(transaction.transaction_invoice_items)) {
                        transaction.transaction_invoice_items.forEach(item => {
                            if (item.invoice_id === invoice.id) {
                                const allocatedAmount = parseAmount(item.paid_amount);
                                transactionData.allocated_to_invoices.push({
                                    invoice_ref: invoice.ref_no,
                                    allocated_amount: allocatedAmount,
                                    invoice_id: item.invoice_id,
                                    transaction_invoice_item_id: item.id
                                });
                            }
                        });
                    }

                    // If transaction has allocations to multiple invoices, store the full allocation data
                    if (transactionData.allocated_to_invoices.length > 0) {
                        transactionAllocations.push(transactionData);
                    }
                });
            }

            // Process transaction_invoice_items if available
            if (invoice.transaction_invoice_items && Array.isArray(invoice.transaction_invoice_items)) {
                console.log('📌 Processing transaction_invoice_items:', invoice.transaction_invoice_items.length);

                invoice.transaction_invoice_items.forEach(item => {
                    transactionInvoiceItems.push({
                        id: item.id,
                        paid_amount: item.paid_amount,
                        balance_amount: item.balance_amount,
                        is_fully_paid: item.is_fully_paid,
                        transaction_id: item.transaction_id,
                        transaction_reference: item.transaction?.reference_no
                    });

                    // Add to payment history with transaction reference
                    if (item.transaction) {
                        paymentHistory.push({
                            id: item.transaction.id,
                            payment_date: item.transaction.date || item.transaction.created_at,
                            reference_no: item.transaction.reference_no || `TR-${item.transaction.id}`,
                            amount: item.paid_amount, // Show allocated amount
                            original_amount: item.transaction.amount,
                            payment_method: item.transaction.account?.type || item.transaction.payment_mode || 'Bank Transfer',
                            status: item.transaction.reconciliation_status === 'reconciled' ? 'Completed' : 'Pending',
                            account_details: item.transaction.account ? {
                                account_name: item.transaction.account.name,
                                account_number: item.transaction.account.account_number,
                                bank_name: item.transaction.account.branch_name
                            } : null,
                            note: `Payment of ${formatUSAmount(item.paid_amount)} applied to this invoice`
                        });
                    }
                });
            }

            // Create enhanced invoice data
            const invoiceWithPaymentData = {
                ...invoice,
                ...(transactionInvoiceItems.length > 0 && {
                    transaction_invoice_items: transactionInvoiceItems
                }),
                ...(transactionAllocations.length > 0 && {
                    transaction_allocations: transactionAllocations
                }),
                ...(invoice.pivot && { pivot: invoice.pivot }),
                invoiceType: type
            };

            console.log('✅ Enhanced Invoice Data:', {
                invoice: invoiceWithPaymentData,
                paymentHistory,
                transactionAllocations
            });

            setSelectedInvoiceDetails(invoiceWithPaymentData);
            setInvoicePaymentHistory(paymentHistory);
            setShowDetailsOffcanvas(true);

        } catch (error) {
            console.error("❌ Error processing invoice details:", error);
            setSelectedInvoiceDetails(invoice);
            setShowDetailsOffcanvas(true);
        }
    };

    const handleCloseTaxInvoiceModal = () => {
        console.log('🔒 Closing tax invoice modal and refreshing data...');
        setShowTaxInvoiceModal(false);
        setSelectedTaxInvoice(null);
        setSelectedTaxQuotation(null);

        // Refresh tax invoices when modal closes
        fetchTaxInvoices(taxPagination.currentPage, true);
    };

    // Function to refresh tax invoices after upload
    const refreshTaxInvoices = async () => {
        console.log('🔄 refreshTaxInvoices called');
        try {
            await fetchTaxInvoices(taxPagination.currentPage, true);
            console.log('✅ refreshTaxInvoices completed');
        } catch (error) {
            console.error('❌ refreshTaxInvoices failed:', error);
        }
    };

    // Function to handle tax invoice upload
    const handleShowTaxUploadModal = (invoice) => {
        setSelectedQuotationForUpload(invoice);
        setShowUploadModal(true);
        setUploadFile(null);
        setErrors({});
    };
    // Add this function to handle tax invoice uploads
    const uploadTaxInvoice = async () => {
        try {
            if (!uploadFile) {
                Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'Please select a tax invoice file', timer: 3000, showConfirmButton: false });
                return;
            }

            if (!selectedQuotationForUpload) {
                Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'No tax invoice selected for upload', timer: 3000, showConfirmButton: false });
                return;
            }

            setUploading(true);

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('tax_invoice_file', uploadFile);

            const response = await axios.post(
                `${backendUrl}/api/taxinvoices/${selectedQuotationForUpload.id}/upload`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                }
            );

            const updatedTaxInvoice = response.data.tax_invoice;

            // Update the tax invoice in the local state
            setTaxInvoices(prev =>
                prev.map(tax => tax.id === selectedQuotationForUpload.id ? updatedTaxInvoice : tax)
            );

            handleCloseUploadModal();
            fetchTaxInvoices(taxPagination.currentPage, true);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Tax invoice document uploaded successfully!',
                timer: 3000,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('Error uploading tax invoice:', error);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.error || 'Failed to upload tax invoice document',
                timer: 3000,
                showConfirmButton: false
            });
        } finally {
            setUploading(false);
        }
    };
    // Delete functions (keep your existing delete logic)
    const deleteProformaInvoice = async (id, journalId) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const API = process.env.REACT_APP_WEBZASH_URL;
            const API_KEY = process.env.REACT_APP_API_KEY;

            await axios.delete(`${backendUrl}/api/proformainvoice/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            if (journalId) {
                await axios.delete(`${API}/api/entries/delete/journal/${journalId}`, {
                    headers: {
                        'x-api-key': API_KEY,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    }
                });
            }

            // Refresh the list
            fetchProformaInvoices(proformaPagination.currentPage, true);

            Swal.fire("Deleted!", "The proforma invoice has been deleted.", "success");
        } catch (error) {
            console.error('Error deleting proforma invoice:', error);
            Swal.fire("Error!", "Failed to delete proforma invoice. Please try again.", "error");
        }
    };

    const deleteTaxInvoice = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.delete(`${backendUrl}/api/taxinvoices/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            // Refresh the list
            fetchTaxInvoices(taxPagination.currentPage, true);

            Swal.fire("Deleted!", "The tax invoice has been deleted.", "success");
        } catch (error) {
            Swal.fire("Error!", "Failed to delete tax invoice. Please try again.", "error");
        }
    };
    const handleDownloadPDF = async (invoiceId, refNo, type = 'tax') => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            console.log(`📥 Starting download for ${type} invoice:`, invoiceId);

            const endpoint = type === 'proforma' ? 'proformainvoice' : 'taxinvoice';
            const response = await axios.get(
                `${backendUrl}/api/${endpoint}/${invoiceId}/download`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob',
                    timeout: 30000
                }
            );

            console.log('📄 Download response:', {
                status: response.status,
                headers: response.headers,
                dataSize: response.data.size,
                dataType: response.data.type
            });

            // Check if we actually got a PDF file
            if (response.data.size === 0) {
                throw new Error('Received empty file');
            }

            // Create blob URL
            const blob = new Blob([response.data], {
                type: response.headers['content-type'] || 'application/pdf'
            });

            const url = window.URL.createObjectURL(blob);

            // Create and trigger download
            const link = document.createElement('a');
            link.href = url;
            link.download = `tax-invoice-${refNo}.pdf`;
            link.style.display = 'none';

            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            console.log('✅ Download triggered successfully');

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'PDF downloaded successfully!',
                timer: 3000,
                showConfirmButton: false,
            });

        } catch (error) {
            console.error('❌ Error downloading PDF:', error);

            let errorMessage = 'Failed to download PDF';
            if (error.response?.status === 404) {
                errorMessage = 'PDF file not found';
            } else if (error.response?.status === 403) {
                errorMessage = 'No permission to download this file';
            } else if (error.message.includes('empty file')) {
                errorMessage = 'The PDF file is empty';
            }

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: errorMessage,
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };
    // Status badge components
    // const PaymentStatusBadge = ({ status }) => {
    //     const statusConfig = {
    //         payment_received: { label: 'Paid', class: 'success' },
    //         PI_generated: { label: 'Unpaid', class: 'warning' },
    //         partial: { label: 'Partial', class: 'info' }
    //     };

    //     const config = statusConfig[status] || { label: status, class: 'secondary' };

    //     return <span className={`badge bg-${config.class}`}>{config.label}</span>;
    // };
    //   const PaymentStatusBadge = ({ status, invoice }) => {
    //     // If invoice data is provided, calculate actual status
    //     if (invoice) {
    //         const totals = calculateInvoiceTotals(invoice, invoice.tax_invoice ? 'tax' : 'proforma');
    //         let badgeClass = 'secondary';

    //         if (totals.isFullyPaid) {
    //             badgeClass = 'success';
    //         } else if (totals.invoicePaidAmount > 0) {
    //             badgeClass = 'info';
    //         } else {
    //             badgeClass = 'warning';
    //         }

    //         return <span className={`badge bg-${badgeClass}`}>
    //             {totals.isFullyPaid ? 'Paid' : totals.invoicePaidAmount > 0 ? 'Partial' : 'Unpaid'}
    //         </span>;
    //     }

    //     // Fallback to status-based badges
    //     const statusConfig = {
    //         payment_received: { label: 'Paid', class: 'success' },
    //         PI_generated: { label: 'Unpaid', class: 'warning' },
    //         partially_paid: { label: 'Partial', class: 'info' },
    //         partial: { label: 'Partial', class: 'info' }
    //     };

    //     const config = statusConfig[status] || { label: status, class: 'secondary' };
    //     return <span className={`badge bg-${config.class}`}>{config.label}</span>;
    // };


    const WorkStatusBadge = ({ status }) => {
        const statusConfig = {
            completed: { label: 'Completed', class: 'success' },
            pending: { label: 'Pending', class: 'warning' },
            in_progress: { label: 'In Progress', class: 'primary' }
        };

        const config = statusConfig[status] || { label: status, class: 'secondary' };

        return <span className={`badge bg-${config.class}`}>{config.label}</span>;
    };

    // Initial data loading
    useEffect(() => {
        fetchProjects();
        fetchClients();
    }, []);

    if (!proformaInvoices) return <div>Loading...</div>;
    const hasDiscount = proformaInvoices.discount_amount && proformaInvoices.discount_amount > 0;
    const TotalAmount = proformaInvoices.amount - proformaInvoices.deduction_amount;
    const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
    const backendUrl = `${API}/api`; // Use this if you want to use
    // const backendUrl = 'http://localhost/webzash/api'; // adjust if needed
    const apiKey = process.env.REACT_APP_API_KEY; // replace with actual key

    const headers = {
        'x-api-key': apiKey,
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    const ensureGroupExists = async (groupName, parentGroupName, cachedGroups = null) => {
        if (!groupName || !parentGroupName) {
            throw new Error("Both groupName and parentGroupName are required");
        }

        const groups = cachedGroups || (await axios.get(`${backendUrl}/groups/index`, { headers })).data;

        const group = groups.find(g => g.Group.name === groupName);
        if (group) return group.Group.id;

        const parentGroup = groups.find(g => g.Group.name === parentGroupName);
        if (!parentGroup) throw new Error(`Parent group "${parentGroupName}" not found`);

        const payload = {
            Group: {
                name: groupName,
                parent_id: parentGroup.Group.id,
                code: null,
                affects_gross: 0,
            },
        };

        const { data: created } = await axios.post(`${backendUrl}/groups/add`, payload, { headers });
        return created.id;
    };


    const ensureLedgerExists = async (ledgerName, groupId, type = 0, credit = false, cachedLedgers = null) => {
        const ledgers = cachedLedgers || (await axios.get(`${backendUrl}/ledgers/index`, { headers })).data.data;

        const existing = ledgers.find(l => l.Ledger?.name === ledgerName);
        if (existing) return existing.Ledger.id;

        const payload = {
            Ledger: {
                name: ledgerName,
                code: null,
                group_id: groupId,
                op_balance: 0,
                op_balance_dc: credit ? "C" : "D",
                notes: "",
                type: type,
            }
        };

        const { data: created } = await axios.post(`${backendUrl}/ledgers/add`, payload, { headers });
        return created?.data?.Ledger?.id || created.Ledger?.id;
    };
    const createVATJournalEntry = async (proformaInvoice) => {
        const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
        const backendUrl = `${API}/api`; // Use this if you want to use dynamic API URL
        // const backendUrl = 'http://localhost/webzash/api'; // Static Webzash API URL
        const apiKey = process.env.REACT_APP_API_KEY;

        const headers = {
            'x-api-key': apiKey,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };

        // const amount = parseFloat(proformaInvoice.amount || 0);
        // const vatAmount = parseFloat(proformaInvoice.vat_amount || (amount * 0.05));
        // const roundedVAT = parseFloat((Math.round(vatAmount * 100) / 100).toFixed(2));
        const currency = proformaInvoice.quotation?.project?.client?.currency || 'AED';
        const isAed = currency === 'AED';
        const isTaxInvoice = proformaInvoice.tax_invoice_generated === true;

        const amount = parseFloat(proformaInvoice.amount || 0);
        const vatAmount = (isAed && isTaxInvoice)
            ? parseFloat(proformaInvoice.vat_amount || (amount * 0.05))
            : 0;

        const roundedVAT = parseFloat((Math.round(vatAmount * 100) / 100).toFixed(2));

        // ✅ Final Condition to skip
        if (!isAed || !isTaxInvoice || roundedVAT === 0) {
            console.warn("⛔ Skipping VAT journal entry: Not AED, tax invoice not generated, or VAT is zero.");
            return;
        }


        const clientName = proformaInvoice.quotation?.project?.client?.name || 'Unknown Client';
        const invoiceRef = proformaInvoice.ref_no;
        const date = new Date().toISOString().split('T')[0];

        // 🔁 Fetch groups & ledgers
        const allGroups = (await axios.get(`${backendUrl}/groups/index`, { headers })).data;
        const allLedgers = (await axios.get(`${backendUrl}/ledgers/index`, { headers })).data.data;

        const clientLedgerId = await ensureLedgerExists(clientName, await ensureGroupExists("Accounts Receivable", "Assets", allGroups), 0, false, allLedgers);
        const vatLedgerId = await ensureLedgerExists("Output VAT", await ensureGroupExists("Duties and Taxes", "Liabilities and Owners Equity", allGroups), 0, true, allLedgers);

        // ✅ Build journal entry
        const entryItems = [
            {
                dc: "D",
                ledger_id: clientLedgerId,
                dr_amount: roundedVAT.toFixed(2),
                cr_amount: "0.00",
            },
            {
                dc: "C",
                ledger_id: vatLedgerId,
                dr_amount: "0.00",
                cr_amount: roundedVAT.toFixed(2),
            }
        ];

        const payload = {
            Entry: {
                tag_id: null,
                number: Date.now(),
                date,
                narration: `VAT Entry for Tax Invoice ${invoiceRef}`,
                is_import: true,
            },
            Entryitem: entryItems,
        };

        try {
            const { data: result } = await axios.post(`${backendUrl}/entries/add/journal`, payload, { headers });
            console.log("✅ VAT journal entry created in Webzash:", result);
            if (result && result.entry_id) {
                const backendUrl1 = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem("user-info"));

                const origin = localStorage.getItem('user-origin');

                const token = userInfo?.token;
                await axios.put(`${backendUrl1}/api/taxinvoices/${proformaInvoice.tax_invoice?.id}`, {
                    journal_id: result.entry_id
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });

                console.log("💾 Journal ID saved to TaxInvoice table:", result.entry_id);
            }
        } catch (error) {
            const msg = error?.response?.data?.message || error.message || "Unknown error";
            console.error("❌ VAT journal entry failed:", msg);
        }
    };
    const handleGenerateTaxInvoice = async (invoiceId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Send the request to update this specific invoice
            const response = await axios.put(`${backendUrl}/api/proformainvoice/${invoiceId}`, {
                generate_tax_invoice: true, // backend triggers generation
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            if (response.data.proforma_invoice) {
                const updatedInvoice = response.data.proforma_invoice;

                // Update the invoice in the local state list
                setProformaInvoices((prevInvoices) =>
                    prevInvoices.map((inv) =>
                        inv.id === invoiceId ? { ...inv, ...updatedInvoice } : inv
                    )
                );

                // Optional: create VAT journal entry if generated
                // if (updatedInvoice.tax_invoice_generated) {
                //     await createVATJournalEntry(updatedInvoice);
                // }

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Tax Invoice Generated Successfully!',
                    timer: 3000,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    }
                });
            } else {
                console.error("Failed to update proforma invoice.");
            }
        } catch (error) {
            console.error("Error generating tax invoice:", error);
            Swal.fire("Error!", "Failed to generate tax invoice.", "error");
        }
    };
    const splitOrderByRevenueType = (order) => {
        const quotation = order.quotation;

        // Get totals from quotation data
        const totalAmountWithSubscription = parseFloat(quotation?.total_amount_with_subscription) || 0;
        const deploymentAmount = parseFloat(quotation?.deplyment_amount) || 0;

        // If we have the actual amounts from quotation, use them
        if (totalAmountWithSubscription > 0 || deploymentAmount > 0) {
            const subscriptionItems = [];
            const deploymentItems = [];

            // Distribute products based on their characteristics
            quotation?.product_item_details?.forEach(item => {
                const product = item.product;
                const isServiceProduct = product?.license_type?.toLowerCase() === 'service';

                if (isServiceProduct) {
                    deploymentItems.push(item);
                } else {
                    subscriptionItems.push(item);
                }
            });

            return {
                subscription: {
                    items: subscriptionItems,
                    total: totalAmountWithSubscription,
                    perMonthTotal: totalAmountWithSubscription / (quotation?.subscription_period || 1),
                    count: subscriptionItems.length
                },
                deployment: {
                    items: deploymentItems,
                    total: deploymentAmount,
                    count: deploymentItems.length
                }
            };
        }

        // Fallback to calculation based on pricing data
        const subscriptionItems = [];
        const deploymentItems = [];
        let subscriptionTotal = 0;
        let deploymentTotal = 0;

        const subscriptionPeriod = quotation?.subscription_period || 1;
        const selectedLicenseType = quotation?.license_type_name?.toLowerCase();

        quotation?.product_item_details?.forEach(item => {
            const product = item.product;
            const pricings = product?.pricings || [];

            // Find matching pricing
            let matchingPricing = null;
            if (selectedLicenseType && pricings.length > 0) {
                matchingPricing = pricings.find(p =>
                    p.license_model?.toLowerCase() === selectedLicenseType
                );
            }
            if (!matchingPricing && pricings.length > 0) {
                matchingPricing = pricings[0];
            }

            const isServiceProduct = product?.license_type?.toLowerCase() === 'service';

            if (matchingPricing) {
                const subscriptionAmount = parseFloat(matchingPricing.price) || 0;
                const deploymentAmount = parseFloat(matchingPricing.deployment_cost) || 0;
                const itemQuantity = parseFloat(item.quantity) || 1;

                if (isServiceProduct) {
                    // Service products go to deployment
                    const itemDeploymentTotal = deploymentAmount * itemQuantity;
                    if (itemDeploymentTotal > 0) {
                        deploymentItems.push({
                            ...item,
                            deploymentAmount: itemDeploymentTotal,
                            totalAmount: itemDeploymentTotal
                        });
                        deploymentTotal += itemDeploymentTotal;
                    }
                } else {
                    // Regular products: both subscription and deployment
                    const itemSubscriptionTotal = subscriptionAmount * itemQuantity;
                    const itemDeploymentTotal = deploymentAmount * itemQuantity;

                    if (itemSubscriptionTotal > 0) {
                        subscriptionItems.push({
                            ...item,
                            amountPerMonth: itemSubscriptionTotal,
                            totalAmount: itemSubscriptionTotal * subscriptionPeriod
                        });
                        subscriptionTotal += itemSubscriptionTotal * subscriptionPeriod;
                    }

                    if (itemDeploymentTotal > 0) {
                        deploymentItems.push({
                            ...item,
                            deploymentAmount: itemDeploymentTotal,
                            totalAmount: itemDeploymentTotal
                        });
                        deploymentTotal += itemDeploymentTotal;
                    }
                }
            } else {
                // Fallback
                const itemTotal = parseFloat(item.subtotal) || 0;
                if (isServiceProduct) {
                    deploymentItems.push({
                        ...item,
                        deploymentAmount: itemTotal,
                        totalAmount: itemTotal
                    });
                    deploymentTotal += itemTotal;
                } else {
                    subscriptionItems.push({
                        ...item,
                        amountPerMonth: itemTotal,
                        totalAmount: itemTotal * subscriptionPeriod
                    });
                    subscriptionTotal += itemTotal * subscriptionPeriod;
                }
            }
        });

        return {
            subscription: {
                items: subscriptionItems,
                total: subscriptionTotal,
                perMonthTotal: subscriptionTotal / (subscriptionPeriod || 1),
                count: subscriptionItems.length
            },
            deployment: {
                items: deploymentItems,
                total: deploymentTotal,
                count: deploymentItems.length
            }
        };
    };
    const handleQuotationClick = (quotation) => {
        setSelectedQuotation(quotation);
        setShowQuotationModal(true);
    };

    const handleShowUploadModal = (quotation) => {
        setSelectedQuotationForUpload(quotation);
        setShowUploadModal(true);
        setUploadFile(null);
        setErrors({});
    };

    const handleCloseUploadModal = () => {
        setShowUploadModal(false);
        setSelectedQuotationForUpload(null);
        setUploadFile(null);
        setErrors({});
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // Validate file type
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Please upload PDF, JPEG, PNG, or Word documents only',
                    timer: 3000,
                    showConfirmButton: false
                });
                return;
            }

            // Validate file size (5MB)
            if (file.size > 5 * 1024 * 1024) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'File size must be less than 5MB',
                    timer: 3000,
                    showConfirmButton: false
                });
                return;
            }

            setUploadFile(file);
        }
    };

    const uploadQuotation = async () => {
        try {
            if (!uploadFile) {
                Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'Please select a quotation file', timer: 3000, showConfirmButton: false });
                return;
            }

            if (!selectedQuotationForUpload) {
                Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'No quotation selected for upload', timer: 3000, showConfirmButton: false });
                return;
            }

            setUploading(true);

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('pi_file', uploadFile);

            const response = await axios.post(
                `${backendUrl}/api/proformainvoice/${selectedQuotationForUpload.id}/upload`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        // ❌ remove 'Content-Type'
                    },
                }
            );

            const updatedQuotation = response.data.invoice;

            setProformaInvoices(prev =>
                prev.map(q => q.id === selectedQuotationForUpload.id ? updatedQuotation : q)
            );

            handleCloseUploadModal();

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Proforma invoice document uploaded successfully!',
                timer: 3000,
                showConfirmButton: false
            });

        } catch (error) {
            console.error('Error uploading quotation:', error);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.error || 'Failed to upload proforma invoice document',
                timer: 3000,
                showConfirmButton: false
            });
        } finally {
            setUploading(false);
        }
    };
    const isSystemGenerated = (quotation) => {
        return quotation?.product_item_details?.length > 0 ||
            quotation?.custom_integration_description ||
            quotation?.is_uploaded === false;
    };

    const isImportedEmpty = (quotation) => {
        return (!quotation?.product_item_details || quotation.product_item_details.length === 0) &&
            !quotation?.custom_integration_description &&
            !quotation?.is_uploaded;
    };

    const hasUploadedDocument = (quotation) => {
        return quotation?.is_uploaded === true && quotation?.quotation_file;
    };

    // const handleProformaInvoiceClick = (invoice) => {
    //      console.log('Selected Invoice:', invoice);
    //     console.log('Invoice Quotation:', invoice.quotation);
    //     console.log('Product Item Details:', invoice.quotation?.product_item_details);

    //     // Process the quotation data the same way as in ProformaInvoiceList
    //     const processedQuotationData = invoice.quotation ? {
    //         ...invoice.quotation,
    //         revenueSplit: splitOrderByRevenueType({ quotation: invoice.quotation })
    //     } : null;

    //     setSelectedProformaInvoice(invoice);
    //     setSelectedQuotation(processedQuotationData); // Store the processed quotation data
    //     setShowProformaModal(true);
    // };

    const handleProformaInvoiceClick = async (invoice) => {
        try {
            console.log('Selected Invoice:', invoice);

            // If product_item_details is not available, fetch the full quotation
            if (!invoice.quotation?.product_item_details) {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem("user-info"));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const quotationResponse = await axios.get(
                    `${backendUrl}/api/quotations/${invoice.quotation_id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                        skipLoader: true,
                    }
                );

                const fullQuotation = quotationResponse.data.quotation || quotationResponse.data.data;
                console.log('Full Quotation with Product Details:', fullQuotation);

                // Process the quotation data
                const processedQuotationData = {
                    ...fullQuotation,
                    revenueSplit: splitOrderByRevenueType(fullQuotation)
                };

                setSelectedProformaInvoice(invoice);
                setSelectedQuotation(processedQuotationData);
            } else {
                // Process the existing quotation data
                const processedQuotationData = {
                    ...invoice.quotation,
                    revenueSplit: splitOrderByRevenueType(invoice.quotation)
                };

                setSelectedProformaInvoice(invoice);
                setSelectedQuotation(processedQuotationData);
            }

            setShowProformaModal(true);
        } catch (error) {
            console.error('Error fetching quotation details:', error);
            // Fallback: use available data even without product details
            const processedQuotationData = invoice.quotation ? {
                ...invoice.quotation,
                revenueSplit: { subscription: { items: [], total: 0, count: 0 }, deployment: { items: [], total: 0, count: 0 } }
            } : null;

            setSelectedProformaInvoice(invoice);
            setSelectedQuotation(processedQuotationData);
            setShowProformaModal(true);
        }
    };
    const handleCloseQuotationModal = () => {
        setShowQuotationModal(false);
        setSelectedQuotation(null);
    };

    const handleCloseProformaModal = () => {
        setShowProformaModal(false);
        setSelectedProformaInvoice(null);
    };

    const deploymentDescriptions = selectedQuotation?.editable_deployment_descriptions
        ? typeof selectedQuotation.editable_deployment_descriptions === 'string'
            ? JSON.parse(selectedQuotation.editable_deployment_descriptions)
            : selectedQuotation.editable_deployment_descriptions
        : {};

    const handleExport = async () => {
        try {
            setExportLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Build export parameters based on current filters
            const exportParams = new URLSearchParams();

            if (filters.dateRange.from) exportParams.append('from_date', filters.dateRange.from);
            if (filters.dateRange.to) exportParams.append('to_date', filters.dateRange.to);
            if (filters.paymentStatus !== 'all') exportParams.append('payment_status', filters.paymentStatus);
            if (filters.workStatus !== 'all') exportParams.append('work_status', filters.workStatus);
            if (filters.taxInvoiceStatus !== 'all') exportParams.append('tax_invoice_status', filters.taxInvoiceStatus);
            if (filters.projectId) exportParams.append('project_id', filters.projectId);
            if (filters.clientId) exportParams.append('client_id', filters.clientId);
            if (filters.searchQuery) exportParams.append('search', filters.searchQuery);

            const response = await axios.get(`${backendUrl}/api/proforma-invoices/export?${exportParams.toString()}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                responseType: 'blob'
            });

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `invoices_export_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Invoices exported successfully!',
                timer: 3000,
                showConfirmButton: false,
            });

        } catch (error) {
            console.error('Export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to export invoices',
                timer: 3000,
                showConfirmButton: false,
            });
        } finally {
            setExportLoading(false);
        }
    };

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
        if (!validTypes.includes(file.type)) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Please select a valid Excel or CSV file',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }

        // Validate file size (10MB limit)
        if (file.size > 10 * 1024 * 1024) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'File size must be less than 10MB',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }

        const result = await Swal.fire({
            title: 'Import Invoices',
            text: 'Are you sure you want to import invoices from this file?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, import!',
            cancelButtonText: 'Cancel'
        });

        if (!result.isConfirmed) {
            // Reset file input
            event.target.value = '';
            return;
        }

        try {
            setImportLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${backendUrl}/api/proforma-invoices/import`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Content-Type': 'multipart/form-data',
                },
            });

            const result = response.data;

            let message = `Import completed successfully`;



            Swal.fire({
                title: 'Import Result',
                html: message,
                icon: 'success',
                confirmButtonText: 'OK'
            });

            // Refresh the invoice list
            if (activeTab === "proforma") {
                fetchProformaInvoices(1, true);
            } else {
                fetchTaxInvoices(1, true);
            }

        } catch (error) {
            console.error('Import error:', error);
            let errorMessage = 'Failed to import invoices';

            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }

            Swal.fire({
                title: 'Import Failed',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setImportLoading(false);
            // Reset file input
            event.target.value = '';
        }
    };


    // Add this function to fetch credit notes
    const fetchCreditNotes = async (page = 1, applyFilters = true) => {
        try {
            setLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let params = { page };

            if (applyFilters) {
                if (creditNoteFilters.dateRange.from) params.from_date = creditNoteFilters.dateRange.from;
                if (creditNoteFilters.dateRange.to) params.to_date = creditNoteFilters.dateRange.to;
                if (creditNoteFilters.status !== 'all') params.status = creditNoteFilters.status;
                if (creditNoteFilters.clientId) params.client_id = creditNoteFilters.clientId;
                if (creditNoteFilters.searchQuery) params.search = creditNoteFilters.searchQuery;
            }

            const response = await axios.get(`${backendUrl}/api/credit-notes`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params
            });

            if (response.data.status === "success") {
                const creditNotesData = response.data.data || {};
                const creditNotesList = creditNotesData.data || response.data.credit_notes?.data || [];

                setCreditNotes(creditNotesList);
                setCreditNotesPagination({
                    currentPage: creditNotesData.current_page || 1,
                    pageCount: creditNotesData.last_page || 1,
                    total: creditNotesData.total || 0
                });

                // Set summary totals for Credit Notes
                // If backend provides total_amount_sum, use it, otherwise estimate
                const totalCount = creditNotesData.total || 0;
                const pageCount = creditNotesList.length;
                let totalAmount = response.data.total_amount_sum || 0;

                if (!totalAmount && pageCount > 0) {
                    const pageTotal = creditNotesList.reduce((sum, note) => sum + (parseFloat(note.total_amount) || 0), 0);
                    totalAmount = (pageTotal / pageCount) * totalCount;
                }

                setSummaryTotals({
                    totalAmount: totalAmount,
                    totalVat: 0,
                    totalWithVat: 0,
                    totalPaid: 0,
                    totalUnpaid: 0,
                    totalPartial: 0
                });
            }

        } catch (error) {
            console.error("Error fetching credit notes:", error);
            Swal.fire("Error!", "Failed to load credit notes.", "error");
        } finally {
            setLoading(false);
        }
    };

    // Add pagination handler
    const handleCreditNotePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchCreditNotes(selectedPage, true);
    };

    // Add credit note preview handler
    const handleCreditNotePreview = (creditNote) => {
        setSelectedCreditNote(creditNote);
        setShowCreditNotePreview(true);
    };


    // Add these functions to your React component
    const handleTaxInvoiceExport = async () => {
        try {
            setExportLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Build export parameters based on current filters
            const exportParams = new URLSearchParams();

            if (filters.dateRange.from) exportParams.append('from_date', filters.dateRange.from);
            if (filters.dateRange.to) exportParams.append('to_date', filters.dateRange.to);
            if (filters.projectId) exportParams.append('project_id', filters.projectId);
            if (filters.clientId) exportParams.append('client_id', filters.clientId);
            if (filters.searchQuery) exportParams.append('search', filters.searchQuery);

            const response = await axios.get(`${backendUrl}/api/taxinvoices/export?${exportParams.toString()}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                responseType: 'blob'
            });

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `tax_invoices_export_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Tax Invoices exported successfully!',
                timer: 3000,
                showConfirmButton: false,
            });

        } catch (error) {
            console.error('Tax Invoice export error:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to export tax invoices',
                timer: 3000,
                showConfirmButton: false,
            });
        } finally {
            setExportLoading(false);
        }
    };

    const handleTaxInvoiceImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
        if (!validTypes.includes(file.type)) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Please select a valid Excel or CSV file',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }

        // Validate file size (10MB limit)
        if (file.size > 10 * 1024 * 1024) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'File size must be less than 10MB',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }

        const result = await Swal.fire({
            title: 'Import Tax Invoices',
            text: 'This will create tax invoices and corresponding proforma invoices. Are you sure?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, import!',
            cancelButtonText: 'Cancel'
        });

        if (!result.isConfirmed) {
            // Reset file input
            event.target.value = '';
            return;
        }

        try {
            setImportLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(`${backendUrl}/api/taxinvoices/import`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Content-Type': 'multipart/form-data',
                },
            });

            const result = response.data;

            let message = `Tax Invoice import completed successfully!<br>
                      Imported: ${result.imported_count}<br>
                      Updated: ${result.updated_count}<br>
                      Skipped: ${result.skipped_count}`;

            if (result.skipped_count > 0 && result.skipped_rows) {
                message += `<br><br>Skipped rows:<br>${result.skipped_rows.join('<br>')}`;
            }

            Swal.fire({
                title: 'Import Result',
                html: message,
                icon: 'success',
                confirmButtonText: 'OK'
            });

            // Refresh the tax invoice list
            fetchTaxInvoices(1, true);

        } catch (error) {
            console.error('Tax Invoice import error:', error);
            let errorMessage = 'Failed to import tax invoices';

            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }

            Swal.fire({
                title: 'Import Failed',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setImportLoading(false);
            // Reset file input
            event.target.value = '';
        }
    };
    const handleCancelCreditNote = async (creditNoteId) => {
        const result = await Swal.fire({
            title: "Cancel Credit Note?",
            text: "This will reverse the journal entry and restore the invoice status. Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, cancel it!",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(
                `${backendUrl}/api/credit-notes/${creditNoteId}/cancel`,
                {
                    reason: "Cancelled by user request"
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                }
            );

            if (response.data.status === "success") {
                // Refresh the credit notes list
                fetchCreditNotes(creditNotesPagination.currentPage, true);

                Swal.fire("Cancelled!", "The credit note has been cancelled.", "success");
            }
        } catch (error) {
            console.error('Error cancelling credit note:', error);
            Swal.fire("Error!", "Failed to cancel credit note. Please try again.", "error");
        }
    };
    const handleCreditNoteDownloadPDF = async (creditNoteId, refNo) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/credit-notes/${creditNoteId}/download`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob'
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.download = `credit-note-${refNo}.pdf`;
            link.click();
            window.URL.revokeObjectURL(url);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Credit Note PDF downloaded successfully!',
                timer: 3000,
                showConfirmButton: false,
            });

        } catch (error) {
            console.error('Error downloading credit note PDF:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to download PDF',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Header */}
                    <div className="row mb-2">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between py-1">
                                <h4 className="mb-0 font-size-16">Invoice Management</h4>
                            </div>
                        </div>
                    </div>

                    {/* Tabs - Made more compact */}
                    <div className="tabs-container mb-2">
                        <div className="d-flex border-bottom">
                            <button
                                className={`tab-button px-3 py-1 ${activeTab === "proforma" ? "active border-primary text-primary border-bottom-2" : "text-muted"}`}
                                onClick={() => setActiveTab("proforma")}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    borderBottom: activeTab === "proforma" ? '2px solid #007bff' : '2px solid transparent',
                                    fontSize: '0.9rem'
                                }}
                            >
                                <FaFileInvoice className="me-1" size={14} />
                                Proforma Invoice ({proformaPagination.total})
                            </button>
                            <button
                                className={`tab-button px-3 py-1 ${activeTab === "tax" ? "active border-primary text-primary border-bottom-2" : "text-muted"}`}
                                onClick={() => setActiveTab("tax")}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    borderBottom: activeTab === "tax" ? '2px solid #007bff' : '2px solid transparent',
                                    fontSize: '0.9rem'
                                }}
                            >
                                <FaMoneyBillWave className="me-1" size={14} />
                                Tax Invoice ({taxPagination.total})
                            </button>
                            <button
                                className={`tab-button px-3 py-1 ${activeTab === "credit-notes" ? "active border-primary text-primary border-bottom-2" : "text-muted"}`}
                                onClick={() => setActiveTab("credit-notes")}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    borderBottom: activeTab === "credit-notes" ? '2px solid #007bff' : '2px solid transparent',
                                    fontSize: '0.9rem'
                                }}
                            >
                                <FaUndo className="me-1" size={14} />
                                Credit Notes ({creditNotesPagination.total})
                            </button>
                        </div>
                    </div>

                    {/* Compact Filter Panel */}
                    <div className="card filter-card mb-2 border-0 shadow-sm">
                        <div className="card-body p-2">
                            <div className="row g-2 align-items-end">
                                {/* Date Preset - Smaller */}
                                <div className="col-md-2">
                                    <label className="form-label small mb-1">Date Preset</label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={filters.datePreset}
                                        onChange={(e) => handleDatePresetChange(e.target.value)}
                                    >
                                        <option value="">Custom</option>
                                        <option value="today">Today</option>
                                        <option value="yesterday">Yesterday</option>
                                        <option value="this_week">This Week</option>
                                        <option value="last_week">Last Week</option>
                                        <option value="this_month">This Month</option>
                                        <option value="last_month">Last Month</option>
                                    </select>
                                </div>

                                {/* Date Range - Smaller */}
                                <div className="col-md-2">
                                    <label className="form-label small mb-1">From</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            value={filters.dateRange.from ? dayjs(filters.dateRange.from) : null}
                                            onChange={(newValue) => {
                                                updateFilter('dateRange', {
                                                    ...filters.dateRange,
                                                    from: newValue ? newValue.format('YYYY-MM-DD') : ''
                                                });
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    variant: "outlined"
                                                },
                                                popper: {
                                                    sx: {
                                                        "& .MuiPaper-root": {
                                                            fontSize: "0.7rem",
                                                            minWidth: 200
                                                        }
                                                    }
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>

                                <div className="col-md-2">
                                    <label className="form-label small mb-1">To</label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            value={filters.dateRange.to ? dayjs(filters.dateRange.to) : null}
                                            onChange={(newValue) => {
                                                updateFilter('dateRange', {
                                                    ...filters.dateRange,
                                                    to: newValue ? newValue.format('YYYY-MM-DD') : ''
                                                });
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    variant: "outlined"
                                                },
                                                popper: {
                                                    sx: {
                                                        "& .MuiPaper-root": {
                                                            fontSize: "0.7rem",
                                                            minWidth: 200
                                                        }
                                                    }
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>

                                {/* Status Filters - Smaller */}
                                {activeTab === "proforma" && (
                                    <>
                                        <div className="col-md-2">
                                            <label className="form-label small mb-1">Payment Status</label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={filters.paymentStatus}
                                                onChange={(e) => updateFilter('paymentStatus', e.target.value)}
                                            >
                                                <option value="all">All Payments</option>
                                                <option value="paid">Paid</option>
                                                <option value="unpaid">Unpaid</option>
                                            </select>
                                        </div>

                                        <div className="col-md-2">
                                            <label className="form-label small mb-1">Tax Invoice</label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={filters.taxInvoiceStatus}
                                                onChange={(e) => updateFilter('taxInvoiceStatus', e.target.value)}
                                            >
                                                <option value="all">All</option>
                                                <option value="generated">Generated</option>
                                                <option value="not_generated">Not Generated</option>
                                            </select>
                                        </div>
                                    </>
                                )}

                                {activeTab === "tax" && (
                                    <>
                                        <div className="col-md-2">
                                            <label className="form-label small mb-1">Document Status</label>
                                            <select
                                                className="form-select form-select-sm"
                                                value={filters.documentStatus}
                                                onChange={(e) => updateFilter('documentStatus', e.target.value)}
                                            >
                                                <option value="all">All Documents</option>
                                                <option value="uploaded">Uploaded</option>
                                                <option value="pending">Pending</option>
                                            </select>
                                        </div>
                                    </>
                                )}

                                {/* Search - Compact */}
                                <div className="col-md-2">
                                    <label className="form-label small mb-1">Search</label>
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text py-1">
                                            <FaSearch size={12} />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search..."
                                            value={filters.searchQuery}
                                            onChange={(e) => updateFilter('searchQuery', e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* Action Buttons - Smaller */}
                                <div className="col-md-2 d-flex gap-1">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={applyFilters}
                                    >
                                        Apply
                                    </button>
                                    <button
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={resetFilters}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Compact Summary Boxes */}
                    <div className="row mb-2">
                        <div className="col-12">
                            <div className="row g-2">
                                {(activeTab === "proforma" || activeTab === "tax") && (
                                    <>
                                        <div className="col-md-2">
                                            <div className="card summary-card border-primary h-100">
                                                <div className="card-body p-2 text-center">
                                                    <h6 className="card-title text-muted mb-1 small">Total Amount</h6>
                                                    <h5 className="fw-bold text-primary mb-0">
                                                        {formatSummaryNumber(summaryTotals.totalAmount)}
                                                    </h5>
                                                    <small className="text-muted small">Excl. VAT</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="card summary-card border-info h-100">
                                                <div className="card-body p-2 text-center">
                                                    <h6 className="card-title text-muted mb-1 small">VAT Amount</h6>
                                                    <h5 className="fw-bold text-info mb-0">
                                                        {formatSummaryNumber(summaryTotals.totalVat)}
                                                    </h5>
                                                    <small className="text-muted small">5% VAT</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="card summary-card border-success h-100">
                                                <div className="card-body p-2 text-center">
                                                    <h6 className="card-title text-muted mb-1 small">Total with VAT</h6>
                                                    <h5 className="fw-bold text-success mb-0">
                                                        {formatSummaryNumber(summaryTotals.totalWithVat)}
                                                    </h5>
                                                    <small className="text-muted small">Incl. VAT</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="card h-100">
                                                <div className="card-body p-2">
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <span className="text-muted small">Paid:</span>
                                                        <span className="fw-bold text-success small">
                                                            {formatSummaryNumber(summaryTotals.totalPaid)}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <span className="text-muted small">Unpaid:</span>
                                                        <span className="fw-bold text-warning small">
                                                            {formatSummaryNumber(summaryTotals.totalUnpaid)}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="text-muted small">Partial:</span>
                                                        <span className="fw-bold text-info small">
                                                            {formatSummaryNumber(summaryTotals.totalPartial)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="card h-100">
                                                <div className="card-body p-2">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="text-muted small">Showing:</span>
                                                        <span className="fw-bold small">
                                                            {activeTab === "proforma" ? proformaInvoices.length : taxInvoices.length} records
                                                        </span>
                                                    </div>
                                                    <div className="d-flex gap-1 mt-1">
                                                        {activeTab === "proforma" && (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-light btn-sm border py-0 px-2"
                                                                    onClick={handleExport}
                                                                    title="Export to Excel"
                                                                >
                                                                    <i className="mdi mdi-file-excel text-success" style={{ fontSize: '0.8rem' }}></i>
                                                                </button>
                                                                <input
                                                                    type="file"
                                                                    accept=".xlsx, .xls"
                                                                    id="importFile"
                                                                    onChange={handleImport}
                                                                    style={{ display: "none" }}
                                                                />
                                                                <label
                                                                    htmlFor="importFile"
                                                                    className="btn btn-light btn-sm border py-0 px-2 mb-0"
                                                                    title="Import from Excel"
                                                                >
                                                                    <i className="mdi mdi-upload text-primary" style={{ fontSize: '0.8rem' }}></i>
                                                                </label>
                                                            </>
                                                        )}
                                                        {activeTab === "tax" && (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-light btn-sm border py-0 px-2"
                                                                    onClick={handleTaxInvoiceExport}
                                                                    title="Export to Excel"
                                                                >
                                                                    <i className="mdi mdi-file-excel text-success" style={{ fontSize: '0.8rem' }}></i>
                                                                </button>
                                                                <input
                                                                    type="file"
                                                                    accept=".xlsx, .xls, .csv"
                                                                    id="importTaxInvoiceFile"
                                                                    onChange={handleTaxInvoiceImport}
                                                                    style={{ display: "none" }}
                                                                />
                                                                <label
                                                                    htmlFor="importTaxInvoiceFile"
                                                                    className="btn btn-light btn-sm border py-0 px-2 mb-0"
                                                                    title="Import from Excel"
                                                                >
                                                                    <i className="mdi mdi-upload text-primary" style={{ fontSize: '0.8rem' }}></i>
                                                                </label>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {activeTab === "credit-notes" && (
                                    <>
                                        <div className="col-md-3">
                                            <div className="card summary-card border-danger h-100">
                                                <div className="card-body p-2 text-center">
                                                    <h6 className="card-title text-muted mb-1 small">Total Credit</h6>
                                                    <h5 className="fw-bold text-danger mb-0">
                                                        -{formatSummaryNumber(summaryTotals.totalAmount)}
                                                    </h5>
                                                    <small className="text-muted small">Credit value</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="card summary-card border-success h-100">
                                                <div className="card-body p-2 text-center">
                                                    <h6 className="card-title text-muted mb-1 small">Approved</h6>
                                                    <h5 className="fw-bold text-success mb-0">
                                                        {formatSummaryNumber(summaryTotals.totalApproved || 0)}
                                                    </h5>
                                                    <small className="text-muted small">Approved credits</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="card summary-card border-warning h-100">
                                                <div className="card-body p-2 text-center">
                                                    <h6 className="card-title text-muted mb-1 small">Pending</h6>
                                                    <h5 className="fw-bold text-warning mb-0">
                                                        {formatSummaryNumber(summaryTotals.totalPending || 0)}
                                                    </h5>
                                                    <small className="text-muted small">Pending approval</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="card summary-card border-secondary h-100">
                                                <div className="card-body p-2 text-center">
                                                    <h6 className="card-title text-muted mb-1 small">Cancelled</h6>
                                                    <h5 className="fw-bold text-secondary mb-0">
                                                        {formatSummaryNumber(summaryTotals.totalCancelled || 0)}
                                                    </h5>
                                                    <small className="text-muted small">Cancelled credits</small>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Invoice Tables */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    {activeTab === "proforma" ? (

                                        <div>
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5 className="card-title mb-0">Proforma Invoices</h5>
                                                <div className="d-flex align-items-center gap-2">
                                                    {/* Import Button */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-light border"
                                                        onClick={handleExport}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Export to Excel"
                                                    >
                                                        <i className="mdi mdi-file-excel text-success"></i>
                                                    </button>

                                                    <input
                                                        type="file"
                                                        accept=".xlsx, .xls"
                                                        id="importFile"
                                                        onChange={handleImport}
                                                        style={{ display: "none" }}
                                                    />
                                                    <label
                                                        htmlFor="importFile"
                                                        className="btn btn-light border mb-0"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Import from Excel"
                                                    >
                                                        <i className="mdi mdi-upload text-primary"></i>
                                                    </label>

                                                </div>
                                            </div>

                                            <div>
                                                <table className="table align-middle table-nowrap table-check table-list">
                                                    <thead className="table-sales-gradient">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Reference No</th>

                                                            <th>Quotation</th>
                                                            <th>Client</th>
                                                            <th>Project</th>
                                                            <th>Date</th>

                                                            <th>Amount</th>
                                                            <th>Received Amount</th>
                                                            <th>Pending Balance</th>
                                                            <th>Payment Status</th>
                                                            {/* <th>Work Status</th> */}
                                                            <th>Tax Invoice</th>
                                                            <th>Credit Status</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {proformaInvoices.length > 0 ? (
                                                            proformaInvoices.map((invoice, index) => (
                                                                <tr key={invoice.id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        {/* <Link to={`/proformainvoice/details/${invoice.id}`} className="dropdown-item"> */}
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleProformaInvoiceClick(invoice)}
                                                                        >
                                                                            {invoice.ref_no}
                                                                        </button>

                                                                    </td>


                                                                    <td>
                                                                        {/* <button 
                                                                            className="dropdown-item"
                                                                            onClick={() => handleQuotationClick(invoice.quotation)}
                                                                        > */}
                                                                        {invoice.quotation?.ref_no}
                                                                        {/* </button> */}
                                                                    </td>
                                                                    <td>{invoice.quotation?.project?.client?.name || ''}</td>
                                                                    <td>{invoice.quotation?.project?.name || ''}</td>
                                                                    <td>
                                                                        {new Date(invoice.invoice_date).toLocaleDateString()}
                                                                    </td>
                                                                    <td>
                                                                        <strong> {formatUSAmount(invoice.amount)}</strong>
                                                                        {/* {invoice.advanced_amount > 0 && (
                                                                            <small className="text-muted d-block">
                                                                                Adv: {invoice.advanced_amount}%
                                                                            </small>
                                                                        )} */}
                                                                    </td>
                                                                    {(() => {
                                                                        const totals = calculateInvoiceTotals(invoice, 'proforma');
                                                                        return (
                                                                            <>
                                                                                <td>
                                                                                    <strong className="text-success">{formatUSAmount(totals.invoicePaidAmount)}</strong>
                                                                                </td>
                                                                                <td>
                                                                                    <strong className={totals.invoiceBalance > 0 ? "text-danger" : "text-success"}>
                                                                                        {formatUSAmount(totals.invoiceBalance)}
                                                                                    </strong>
                                                                                </td>
                                                                            </>
                                                                        );
                                                                    })()}
                                                                    <td>
                                                                        <PaymentStatusBadge status={invoice.pi_status} />
                                                                    </td>
                                                                    {/* <td>
                                                                        <WorkStatusBadge status={invoice.work_status || 'pending'} />
                                                                    </td> */}
                                                                    <td>
                                                                        {invoice.tax_invoice_generated ? (
                                                                            <span className="badge bg-success">Generated</span>
                                                                        ) : (
                                                                            <span className="badge bg-warning">Not Generated</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {hasCreditNote(invoice) || (invoice.tax_invoice && hasCreditNote(invoice.tax_invoice)) ? (
                                                                            <span className={`badge ${invoice.status === 'fully_credited' || invoice.tax_invoice?.status === 'fully_credited' ? 'bg-danger' : 'bg-danger'}`}>
                                                                                {invoice.status === 'fully_credited' || invoice.tax_invoice?.status === 'fully_credited' ? 'Fully Credited' : 'Fully Credited'}
                                                                            </span>
                                                                        ) : (
                                                                            <span></span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <div className="dropdown">
                                                                            <i
                                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                style={{ cursor: "pointer" }}
                                                                            ></i>
                                                                            <ul className="dropdown-menu">
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => handleViewDetails(invoice, 'tax')}
                                                                                    >
                                                                                        View Details
                                                                                    </button>
                                                                                </li>
                                                                                <li>
                                                                                    {invoice.tax_invoice_generated ? (
                                                                                        <Link
                                                                                            to={`/tax-invoice/details/${invoice?.tax_invoice?.id}`}
                                                                                            className="dropdown-item"
                                                                                        >
                                                                                            Tax Invoice Details
                                                                                        </Link>
                                                                                    ) : (
                                                                                        <li>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => handleGenerateTaxInvoice(invoice.id)}
                                                                                            >
                                                                                                Generate Tax Invoice
                                                                                            </button>
                                                                                        </li>
                                                                                    )}
                                                                                </li>
                                                                                {invoice.credit_notes && invoice.credit_notes.length > 0 ? (
                                                                                    <li>
                                                                                        <button
                                                                                            className="dropdown-item"
                                                                                            onClick={() => {
                                                                                                // Show the first credit note (or you can show a list if multiple)
                                                                                                const latestCreditNote = invoice.credit_notes[invoice.credit_notes.length - 1];
                                                                                                setSelectedCreditNote(latestCreditNote);
                                                                                                setShowCreditNotePreview(true);
                                                                                            }}
                                                                                        >
                                                                                            <i className="fa fa-file-invoice me-1"></i>
                                                                                            View Credit Note

                                                                                        </button>
                                                                                    </li>
                                                                                ) : (
                                                                                    <li>
                                                                                        <button
                                                                                            className="dropdown-item"
                                                                                            onClick={() => handleCreateCreditNote(invoice, 'proforma')}
                                                                                        >
                                                                                            <i className="fa fa-undo me-1"></i>
                                                                                            Create Credit Note
                                                                                        </button>
                                                                                    </li>
                                                                                )}
                                                                                <WithDeletePermission>
                                                                                    <li>
                                                                                        <button
                                                                                            className="dropdown-item text-danger"
                                                                                            onClick={() => deleteProformaInvoice(invoice.id, invoice.journal_id)}
                                                                                        >
                                                                                            Delete
                                                                                        </button>
                                                                                    </li>
                                                                                </WithDeletePermission>
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="11" className="text-center py-4">
                                                                    <div className="text-muted">
                                                                        <FaFileInvoice size={48} className="mb-2" />
                                                                        <p>No proforma invoices found</p>
                                                                        <small>Try adjusting your filters or create a new invoice</small>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                    {/* Proforma Table Footer */}
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="1" className="text-center">
                                                            </td>
                                                            <td colSpan="5" className="text-end">
                                                                <strong>Grand Total:</strong>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex flex-column">
                                                                    <strong>{formatUSAmount(calculateProformaTableTotals().amountSum)}</strong>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <strong className="text-success">{formatUSAmount(calculateProformaTableTotals().paidAmountSum)}</strong>
                                                            </td>
                                                            <td>
                                                                <strong className="text-danger">{formatUSAmount(calculateProformaTableTotals().balanceSum)}</strong>
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>


                                            <div className="d-flex justify-content-end pagination-sm">
                                                <ReactPaginate
                                                    previousLabel={'<'}
                                                    nextLabel={'>'}
                                                    breakLabel={'...'}
                                                    pageCount={proformaPagination.pageCount}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={3}
                                                    onPageChange={handleProformaPageClick}
                                                    containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link'}
                                                    previousClassName={'page-item previous'}
                                                    previousLinkClassName={'page-link'}
                                                    nextClassName={'page-item next'}
                                                    nextLinkClassName={'page-link'}
                                                    breakClassName={'page-item'}
                                                    breakLinkClassName={'page-link'}
                                                    activeClassName={'active'}
                                                />
                                            </div>
                                        </div>


                                    ) : activeTab === "tax" ? (
                                        <div>
                                            {/* Tax Invoices Table */}
                                            <div>
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h5 className="card-title mb-0">Tax Invoices</h5>
                                                    <div className="d-flex align-items-center gap-2">
                                                        {/* Export Button */}
                                                        <button
                                                            type="button"
                                                            className="btn btn-light border"
                                                            onClick={handleTaxInvoiceExport}
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            title="Export to Excel"
                                                            disabled={exportLoading}
                                                        >
                                                            {exportLoading ? (
                                                                <div className="spinner-border spinner-border-sm" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            ) : (
                                                                <i className="mdi mdi-file-excel text-success"></i>
                                                            )}
                                                        </button>

                                                        {/* Import Button */}
                                                        <input
                                                            type="file"
                                                            accept=".xlsx, .xls, .csv"
                                                            id="importTaxInvoiceFile"
                                                            onChange={handleTaxInvoiceImport}
                                                            style={{ display: "none" }}
                                                        />
                                                        <label
                                                            htmlFor="importTaxInvoiceFile"
                                                            className="btn btn-light border mb-0"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            title="Import from Excel"
                                                        >
                                                            {importLoading ? (
                                                                <div className="spinner-border spinner-border-sm" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            ) : (
                                                                <i className="mdi mdi-upload text-primary"></i>
                                                            )}
                                                        </label>
                                                    </div>
                                                </div>
                                                <table className="table align-middle table-nowrap table-check table-list">
                                                    <thead className="table-sales-gradient">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Date</th>
                                                            <th>Reference No</th>
                                                            <th>Client</th>
                                                            <th>Project</th>
                                                            <th>Amount</th>
                                                            <th>VAT Amount</th>
                                                            <th>Total with VAT</th>
                                                            <th>Received Amount</th>
                                                            <th>Pending Balance</th>
                                                            {/* <th>Status</th> */}
                                                            <th>Payment Status</th>
                                                            <th>Credit Status</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {taxInvoices.length > 0 ? (
                                                            taxInvoices.map((invoice, index) => (
                                                                <tr key={invoice.id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleTaxInvoiceClick(invoice)}
                                                                            style={{
                                                                                border: 'none',
                                                                                background: 'none',
                                                                                cursor: 'pointer',
                                                                                fontWeight: '500'
                                                                            }}
                                                                            title="Click to preview tax invoice"
                                                                        >

                                                                            {new Date(invoice.date).toLocaleDateString()}                                    </button>
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            onClick={() => handleTaxInvoiceClick(invoice)}
                                                                            style={{
                                                                                border: 'none',
                                                                                background: 'none',
                                                                                cursor: 'pointer',
                                                                                fontWeight: '500'
                                                                            }}
                                                                            title="Click to preview tax invoice"
                                                                        >
                                                                            <i className="fa fa-file-invoice me-1 small"></i>
                                                                            {invoice.ref_no}
                                                                        </button>
                                                                    </td>
                                                                    <td>{invoice.proforma_invoice?.quotation?.project?.client?.name || ''}</td>
                                                                    <td>{invoice.proforma_invoice?.quotation?.project?.name || ''}</td>
                                                                    <td><strong> {formatUSAmount(invoice.proforma_invoice?.basic_amount)}</strong></td>
                                                                    <td> {formatUSAmount(invoice.vat_amount) || '0.00'}</td>
                                                                    <td><strong> {formatUSAmount(invoice.total_with_vat)}</strong></td>
                                                                    {(() => {
                                                                        const totals = calculateInvoiceTotals(invoice, 'tax');
                                                                        return (
                                                                            <>
                                                                                <td>
                                                                                    <strong className="text-success">{formatUSAmount(totals.invoicePaidAmount)}</strong>
                                                                                </td>
                                                                                <td>
                                                                                    <strong className={totals.invoiceBalance > 0 ? "text-danger" : "text-success"}>
                                                                                        {formatUSAmount(totals.invoiceBalance)}
                                                                                    </strong>
                                                                                </td>
                                                                            </>
                                                                        );
                                                                    })()}
                                                                    {/* <td>
                                                                        <span className={`badge bg-${invoice.status === 'paid' ? 'success' : 'warning'}`}>
                                                                            {invoice.status || 'generated'}
                                                                        </span>
                                                                    </td> */}
                                                                    <td>
                                                                        <PaymentStatusBadge status={invoice.proforma_invoice?.pi_status} />
                                                                    </td>
                                                                    <td>
                                                                        {hasCreditNote(invoice) || (invoice.proforma_invoice && (hasCreditNote(invoice.proforma_invoice) || invoice.proforma_invoice.status === 'fully_credited')) ? (
                                                                            <span className={`badge ${invoice.status === 'fully_credited' || invoice.proforma_invoice?.status === 'fully_credited' ? 'bg-danger' : 'bg-danger'}`}>
                                                                                {invoice.status === 'fully_credited' || invoice.proforma_invoice?.status === 'fully_credited' ? 'Fully Credited' : 'Fully Credited'}
                                                                            </span>
                                                                        ) : (
                                                                            <span></span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <div className="dropdown">
                                                                            <i
                                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                style={{ cursor: "pointer" }}
                                                                            ></i>
                                                                            <ul className="dropdown-menu">
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => handleViewDetails(invoice, 'tax')}
                                                                                    >
                                                                                        View Details
                                                                                    </button>
                                                                                </li>
                                                                                {invoice.credit_notes && invoice.credit_notes.length > 0 ? (
                                                                                    <li>
                                                                                        <button
                                                                                            className="dropdown-item"
                                                                                            onClick={() => {
                                                                                                // Show the first credit note (or you can show a list if multiple)
                                                                                                const latestCreditNote = invoice.credit_notes[invoice.credit_notes.length - 1];
                                                                                                setSelectedCreditNote(latestCreditNote);
                                                                                                setShowCreditNotePreview(true);
                                                                                            }}
                                                                                        >
                                                                                            <i className="fa fa-file-invoice me-1"></i>
                                                                                            View Credit Note

                                                                                        </button>
                                                                                    </li>
                                                                                ) : (
                                                                                    <li>
                                                                                        <button
                                                                                            className="dropdown-item"
                                                                                            onClick={() => handleCreateCreditNote(invoice, 'tax')}
                                                                                        >
                                                                                            <i className="fa fa-undo me-1"></i>
                                                                                            Create Credit Note
                                                                                        </button>
                                                                                    </li>
                                                                                )}
                                                                                {(!invoice.proforma_invoice?.quotation?.product_item_details ||
                                                                                    invoice.proforma_invoice?.quotation?.product_item_details.length === 0) && (
                                                                                        <li>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => handleShowTaxUploadModal(invoice)}
                                                                                            >
                                                                                                <i className="fa fa-upload me-1"></i>
                                                                                                Upload Document
                                                                                            </button>
                                                                                        </li>
                                                                                    )}
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item text-danger"
                                                                                        onClick={() => deleteTaxInvoice(invoice.id)}
                                                                                    >
                                                                                        Delete
                                                                                    </button>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10" className="text-center py-4">
                                                                    <div className="text-muted">
                                                                        <FaMoneyBillWave size={48} className="mb-2" />
                                                                        <p>No tax invoices found</p>
                                                                        <small>Try adjusting your filters</small>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                    {/* Tax Table Footer */}
                                                    <tfoot >
                                                        <tr>
                                                            <td colSpan="1" className="text-center">
                                                            </td>
                                                            <td colSpan="4" className="text-end">
                                                                <strong>Grand Total:</strong>
                                                            </td>
                                                            <td>
                                                                <strong className="text-primary">
                                                                    {formatUSAmount(calculateTaxTableTotals().basicAmountSum)}
                                                                </strong>
                                                            </td>
                                                            <td>
                                                                <strong className="text-info">
                                                                    {formatUSAmount(calculateTaxTableTotals().vatAmountSum)}
                                                                </strong>
                                                            </td>
                                                            <td>
                                                                <strong className="text-success">
                                                                    {formatUSAmount(calculateTaxTableTotals().totalWithVatSum)}
                                                                </strong>
                                                            </td>
                                                            <td>
                                                                <strong className="text-success">{formatUSAmount(calculateTaxTableTotals().paidAmountSum)}</strong>
                                                            </td>
                                                            <td>
                                                                <strong className="text-danger">{formatUSAmount(calculateTaxTableTotals().balanceSum)}</strong>
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                            <div className="d-flex justify-content-end pagination-sm">
                                                <ReactPaginate
                                                    previousLabel={'<'}
                                                    nextLabel={'>'}
                                                    breakLabel={'...'}
                                                    pageCount={taxPagination.pageCount}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={3}
                                                    onPageChange={handleTaxPageClick}
                                                    containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link'}
                                                    previousClassName={'page-item previous'}
                                                    previousLinkClassName={'page-link'}
                                                    nextClassName={'page-item next'}
                                                    nextLinkClassName={'page-link'}
                                                    breakClassName={'page-item'}
                                                    breakLinkClassName={'page-link'}
                                                    activeClassName={'active'}
                                                />
                                            </div>
                                        </div>
                                    ) : activeTab === "credit-notes" ? (
                                        <div>
                                            {/* Credit Notes Filters - similar to other filters */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5 className="card-title mb-0">Credit Notes</h5>
                                            </div>

                                            <div className="table-responsive">
                                                <table className="table align-middle table-nowrap table-check table-list">
                                                    <thead className="table-sales-gradient">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Credit Note No</th>
                                                            <th>Date</th>
                                                            <th>Original Invoice</th>
                                                            <th>Client</th>
                                                            <th>Amount</th>
                                                            <th>Type</th>
                                                            <th>Status</th>
                                                            <th>Reason</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {creditNotes.length > 0 ? (
                                                            creditNotes.map((note, index) => (
                                                                <tr key={note.id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        <button
                                                                            className="btn dropdown-item p-0 text-decoration-none text-dark"
                                                                            onClick={() => handleCreditNotePreview(note)}
                                                                            title="View Credit Note Details"
                                                                        >
                                                                            <strong>{note.ref_no}</strong>
                                                                        </button>
                                                                    </td>
                                                                    <td>{new Date(note.date).toLocaleDateString()}</td>
                                                                    <td>
                                                                        <div>{note.invoice?.ref_no || ''}</div>
                                                                        {note.invoice?.proforma_invoice && (
                                                                            <small className="text-muted d-block">
                                                                                {note.invoice.proforma_invoice.ref_no}
                                                                            </small>
                                                                        )}
                                                                    </td>
                                                                    <td>{note.client?.name || ''}</td>
                                                                    <td>
                                                                        <strong className="text-danger">
                                                                            -{formatUSAmount(note.total_amount)}
                                                                        </strong>
                                                                    </td>
                                                                    <td>
                                                                        <Badge bg={note.credit_type === 'full' ? 'success' : 'info'}>
                                                                            {note.credit_type}
                                                                        </Badge>
                                                                    </td>
                                                                    <td>
                                                                        {note.status === 'approved' ? (
                                                                            <Badge bg="success">Approved</Badge>
                                                                        ) : note.status === 'pending' ? (
                                                                            <Badge bg="warning">Pending</Badge>
                                                                        ) : note.status === 'cancelled' ? (
                                                                            <Badge bg="danger">Cancelled</Badge>
                                                                        ) : (
                                                                            <Badge bg="secondary">{note.status}</Badge>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <small className="text-muted" style={{ maxWidth: '150px', display: 'block' }}>
                                                                            {note.reason?.substring(0, 50)}
                                                                            {note.reason?.length > 50 ? '...' : ''}
                                                                        </small>
                                                                    </td>
                                                                    <td>
                                                                        <div className="dropdown">
                                                                            <i
                                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                style={{ cursor: "pointer" }}
                                                                            ></i>
                                                                            <ul className="dropdown-menu">
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => handleCreditNotePreview(note)}
                                                                                    >
                                                                                        <FaEye className="me-1" />
                                                                                        View Details
                                                                                    </button>
                                                                                </li>
                                                                                <li>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => handleDownloadPDF(note.id, note.ref_no)}
                                                                                    >
                                                                                        <FaDownload className="me-1" />
                                                                                        Download PDF
                                                                                    </button>
                                                                                </li>
                                                                                {note.status === 'approved' && (
                                                                                    <li>
                                                                                        <button
                                                                                            className="dropdown-item text-danger"
                                                                                            onClick={() => handleCancelCreditNote(note.id)}
                                                                                        >
                                                                                            <FaTimes className="me-1" />
                                                                                            Cancel Credit Note
                                                                                        </button>
                                                                                    </li>
                                                                                )}
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10" className="text-center py-4">
                                                                    <div className="text-muted">
                                                                        <FaFileInvoice size={48} className="mb-2" />
                                                                        <p>No credit notes found</p>
                                                                        <small>Create a credit note from an invoice</small>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                    {/* Credit Notes Table Footer */}
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="1" className="text-center">
                                                            </td>
                                                            <td colSpan="4" className="text-end">
                                                                <strong>Grand Total:</strong>
                                                            </td>

                                                            <td colSpan="2"></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                            {/* Pagination for credit notes */}
                                            <div className="d-flex justify-content-end pagination-sm">
                                                <ReactPaginate
                                                    previousLabel={'<'}
                                                    nextLabel={'>'}
                                                    breakLabel={'...'}
                                                    pageCount={creditNotesPagination.pageCount}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={3}
                                                    onPageChange={handleCreditNotePageClick}
                                                    containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link'}
                                                    previousClassName={'page-item previous'}
                                                    previousLinkClassName={'page-link'}
                                                    nextClassName={'page-item next'}
                                                    nextLinkClassName={'page-link'}
                                                    breakClassName={'page-item'}
                                                    breakLinkClassName={'page-link'}
                                                    activeClassName={'active'}
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Offcanvas show={showUploadModal} onHide={handleCloseUploadModal} style={{ width: '500px' }} placement='end'>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        {activeTab === "proforma" ? 'Upload Proforma Invoice Document' : 'Upload Tax Invoice Document'}
                        {selectedQuotationForUpload && (
                            <div className="small text-muted mt-1">
                                For: {selectedQuotationForUpload.ref_no} - {selectedQuotationForUpload?.project?.client?.name} - {selectedQuotationForUpload?.project?.name}
                            </div>
                        )}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {selectedQuotationForUpload && (
                        <div className="mt-3 p-3 border rounded bg-light">
                            <h6 className="mb-2">Invoice Details:</h6>
                            <div className="row small">
                                <div className="col-md-6">
                                    <strong>Reference:</strong> {selectedQuotationForUpload.ref_no}
                                </div>
                                <div className="col-md-6">
                                    <strong>Client:</strong> {selectedQuotationForUpload?.project?.client?.name}
                                </div>
                                <div className="col-md-6">
                                    <strong>Project:</strong> {selectedQuotationForUpload?.project?.name}
                                </div>
                                <div className="col-md-6">
                                    <strong>Type:</strong> {activeTab === "proforma" ? 'Proforma Invoice' : 'Tax Invoice'}
                                </div>
                            </div>
                        </div>
                    )}
                    <br /><br />
                    <Form.Group>
                        <Form.Label>Document *</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            isInvalid={errors.quotation_file}
                        />
                        <Form.Text className="text-muted">
                            Supported formats: PDF, Word, JPEG, PNG (Max: 5MB)
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">
                            {errors.quotation_file}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Offcanvas.Body>
                <div className="offcanvas-footer p-3 border-top d-flex justify-content-end">
                    <Button variant="secondary" onClick={handleCloseUploadModal}>
                        Cancel
                    </Button>&nbsp;
                    <Button
                        variant="primary"
                        onClick={activeTab === "proforma" ? uploadQuotation : uploadTaxInvoice}
                        disabled={uploading || !uploadFile}
                    >
                        {uploading ? 'Uploading...' : 'Upload'}
                    </Button>
                </div>
            </Offcanvas>

            {/* Invoice Details Offcanvas */}
            <Offcanvas
                show={showDetailsOffcanvas}
                onHide={() => setShowDetailsOffcanvas(false)}
                placement="end"
                style={{ width: '800px' }}
            >
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title className="w-100">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0">Invoice Details</h5>
                                {selectedInvoiceDetails && (
                                    <small className="text-muted">
                                        {selectedInvoiceDetails.ref_no}
                                        {selectedInvoiceDetails.pi_status === 'payment_received' &&
                                            <span className="ms-2">
                                                <FaCheckCircle className="text-success" />
                                            </span>
                                        }
                                    </small>
                                )}
                            </div>
                            {selectedInvoiceDetails && (
                                <div className="d-flex align-items-center gap-2">
                                    {selectedInvoiceDetails.tax_invoice_generated === "1" || selectedInvoiceDetails.tax_invoice_generated === true || selectedInvoiceDetails.tax_invoice ? (
                                        <Badge bg="success" className="fs-6">
                                            <FaCheckCircle className="me-1" /> Tax Invoice Generated
                                        </Badge>
                                    ) : null

                                    }
                                    {selectedInvoiceDetails.pi_status === 'payment_received' && (
                                        <Badge bg="success" className="fs-6">
                                            <FaCheckCircle className="me-1" /> Paid
                                        </Badge>
                                    )}
                                </div>
                            )}
                        </div>
                    </Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    {selectedInvoiceDetails ? (
                        <>
                            {/* Basic Information Card */}
                            <Card className="mb-4">
                                <Card.Header className="bg-light">
                                    <h6 className="mb-0">Basic Information</h6>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="mb-2">
                                        <Col sm={4}><strong>Invoice Ref:</strong></Col>
                                        <Col sm={8}>{selectedInvoiceDetails.ref_no}</Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col sm={4}><strong>Invoice Date:</strong></Col>
                                        <Col sm={8}>
                                            {new Date(
                                                selectedInvoiceDetails.invoice_date ||
                                                selectedInvoiceDetails.date ||
                                                selectedInvoiceDetails.created_at
                                            ).toLocaleDateString()}
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col sm={4}><strong>Client:</strong></Col>
                                        <Col sm={8}>
                                            {selectedInvoiceDetails.quotation?.project?.client?.name ||
                                                selectedInvoiceDetails.proforma_invoice?.quotation?.project?.client?.name ||
                                                'N/A'}
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col sm={4}><strong>Project:</strong></Col>
                                        <Col sm={8}>
                                            {selectedInvoiceDetails.quotation?.project?.name ||
                                                selectedInvoiceDetails.proforma_invoice?.quotation?.project?.name ||
                                                'N/A'}
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col sm={4}><strong>Quotation Ref:</strong></Col>
                                        <Col sm={8}>
                                            {selectedInvoiceDetails.quotation?.ref_no ||
                                                selectedInvoiceDetails.proforma_invoice?.quotation?.ref_no ||
                                                'N/A'}
                                        </Col>
                                    </Row>
                                    {/* <Row className="mb-2">
                                        <Col sm={4}><strong>Payment Status:</strong></Col>
                                        <Col sm={8}>
                                            {selectedInvoiceDetails.pi_status === 'payment_received' ? (
                                                <Badge bg="success">
                                                    <FaCheckCircle className="me-1" /> Paid
                                                </Badge>
                                            ) : selectedInvoiceDetails.pi_status === 'PI_generated' ? (
                                                <Badge bg="warning">Unpaid</Badge>
                                            ) : selectedInvoiceDetails.pi_status === 'partial' ? (
                                                <Badge bg="info">Partial Payment</Badge>
                                            ) : (
                                                <Badge bg="secondary">N/A</Badge>
                                            )}
                                        </Col>
                                    </Row> */}
                                </Card.Body>
                            </Card>

                            {/* Invoice Financial Summary */}
                            {/* <Card className="mb-4">
                                <Card.Header className="bg-light">
                                    <h6 className="mb-0">Invoice Financial Summary</h6>
                                </Card.Header>
                                <Card.Body>
                                    {(() => {
                                        const type = selectedInvoiceDetails.tax_invoice ? 'tax' : 'proforma';
                                        const totals = calculateInvoiceTotals(selectedInvoiceDetails, type);

                                        return (
                                            <>
                                                <Row className="mb-2">
                                                    <Col sm={8}><strong>Invoice Amount:</strong></Col>
                                                    <Col sm={4} className="text-end">
                                                        {formatUSAmount(totals.invoiceAmount)} {totals.currency}
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Col sm={8}><strong>VAT Amount:</strong></Col>
                                                    <Col sm={4} className="text-end">
                                                        {formatUSAmount(totals.vatAmount)} {totals.currency}
                                                    </Col>
                                                </Row>
                                                {selectedInvoiceDetails.deduction_amount && parseAmount(selectedInvoiceDetails.deduction_amount) > 0 && (
                                                    <Row className="mb-2">
                                                        <Col sm={8}><strong>Deduction:</strong></Col>
                                                        <Col sm={4} className="text-end text-danger">
                                                            -{formatUSAmount(selectedInvoiceDetails.deduction_amount)} {totals.currency}
                                                        </Col>
                                                    </Row>
                                                )}
                                                <hr />
                                                <Row className="mb-3">
                                                    <Col sm={8}><strong>Total Invoice Amount:</strong></Col>
                                                    <Col sm={4} className="text-end">
                                                        <strong>{formatUSAmount(totals.invoiceTotalWithVat)} {totals.currency}</strong>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Col sm={8}><strong>Amount Paid for this Invoice:</strong></Col>
                                                    <Col sm={4} className="text-end">
                                                        <span className="text-success">
                                                            {formatUSAmount(totals.invoicePaidAmount)} {totals.currency}
                                                        </span>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Col sm={8}><strong>Invoice Balance:</strong></Col>
                                                    <Col sm={4} className="text-end">
                                                        <span className={totals.invoiceBalance > 0 ? 'text-danger' : 'text-success'}>
                                                            {formatUSAmount(totals.invoiceBalance)} {totals.currency}
                                                        </span>
                                                    </Col>
                                                </Row>

                                                {selectedInvoiceDetails.paid_date && (
                                                    <Row className="mb-2 mt-3">
                                                        <Col sm={8}><strong>Paid Date:</strong></Col>
                                                        <Col sm={4} className="text-end">
                                                            {new Date(selectedInvoiceDetails.paid_date).toLocaleDateString()}
                                                        </Col>
                                                    </Row>
                                                )}
                                            </>
                                        );
                                    })()}
                                </Card.Body>
                            </Card> */}
                            {/* Invoice Financial Summary */}
                            <Card className="mb-4">
                                <Card.Header className="bg-light">
                                    <h6 className="mb-0">Invoice Financial Summary</h6>
                                    {selectedInvoiceDetails?.transaction_invoice_items?.length > 0 && (
                                        <small className="text-muted d-block">
                                            <FaInfoCircle className="me-1" />
                                            Payment records available
                                        </small>
                                    )}
                                    {selectedInvoiceDetails?.pivot?.allocated_amount && (
                                        <small className="text-muted d-block">
                                            <FaInfoCircle className="me-1" />
                                            Payment allocated from transaction
                                        </small>
                                    )}
                                </Card.Header>
                                <Card.Body>
                                    {(() => {
                                        const type = selectedInvoiceDetails.invoiceType ||
                                            (selectedInvoiceDetails.tax_invoice ? 'tax' : 'proforma');
                                        const totals = calculateInvoiceTotals(selectedInvoiceDetails, type);

                                        return (
                                            <>
                                                {/* Invoice Breakdown */}
                                                <div className="mb-3">
                                                    <Row className="mb-2">
                                                        <Col sm={8}>
                                                            <strong>Invoice Amount (excl. VAT):</strong>
                                                            <div className="small text-muted">
                                                                Basic amount before VAT
                                                            </div>
                                                        </Col>
                                                        <Col sm={4} className="text-end">
                                                            {formatUSAmount(totals.invoiceAmount)} {totals.currency}
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-2">
                                                        <Col sm={8}>
                                                            <strong>VAT Amount (5%):</strong>
                                                            <div className="small text-muted">
                                                                Tax calculated at 5%
                                                            </div>
                                                        </Col>
                                                        <Col sm={4} className="text-end">
                                                            {formatUSAmount(totals.vatAmount)} {totals.currency}
                                                        </Col>
                                                    </Row>

                                                    <hr />

                                                    <Row className="mb-3">
                                                        <Col sm={8}>
                                                            <strong>Total Invoice Amount:</strong>
                                                            <div className="small text-muted">
                                                                Amount due including VAT
                                                            </div>
                                                        </Col>
                                                        <Col sm={4} className="text-end">
                                                            <h5 className="mb-0 text-primary">
                                                                {formatUSAmount(totals.invoiceTotalWithVat)} {totals.currency}
                                                            </h5>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                {/* Payment Status */}
                                                <div className="payment-status-section p-3 bg-light rounded">
                                                    <h6 className="mb-3">Payment Status</h6>

                                                    <Row className="mb-2">
                                                        <Col sm={8}>
                                                            <strong>Amount Paid:</strong>
                                                            {selectedInvoiceDetails?.paid_date && (
                                                                <div className="small text-muted">
                                                                    Paid on: {new Date(selectedInvoiceDetails.paid_date).toLocaleDateString()}
                                                                </div>
                                                            )}
                                                        </Col>
                                                        <Col sm={4} className="text-end">
                                                            <h5 className={`mb-0 ${totals.invoicePaidAmount > 0 ? 'text-success' : 'text-muted'}`}>
                                                                {formatUSAmount(totals.invoicePaidAmount)} {totals.currency}
                                                            </h5>
                                                            {totals.invoicePaidAmount > 0 && (
                                                                <div className="small">
                                                                    {((totals.invoicePaidAmount / totals.invoiceTotalWithVat) * 100).toFixed(1)}% of total
                                                                </div>
                                                            )}
                                                        </Col>
                                                    </Row>

                                                    <Row className="mb-3">
                                                        <Col sm={8}>
                                                            <strong>Balance Due:</strong>
                                                            <div className="small text-muted">
                                                                Remaining amount to be paid
                                                            </div>
                                                        </Col>
                                                        <Col sm={4} className="text-end">
                                                            <h5 className={`mb-0 ${totals.invoiceBalance > 0 ? 'text-danger' :
                                                                totals.invoiceBalance < 0 ? 'text-warning' : 'text-success'
                                                                }`}>
                                                                {formatUSAmount(totals.invoiceBalance)} {totals.currency}
                                                            </h5>


                                                        </Col>
                                                    </Row>

                                                    {/* Status Badge */}
                                                    <div className="text-center mt-3">
                                                        {totals.isFullyPaid ? (
                                                            <Badge bg="success" className="fs-6 p-2 px-4">
                                                                <FaCheckCircle className="me-2" />
                                                                <strong>PAID IN FULL</strong>
                                                            </Badge>
                                                        ) : totals.invoicePaidAmount > 0 ? (
                                                            <Badge bg="info" className="fs-6 p-2 px-4">
                                                                <FaInfoCircle className="me-2" />
                                                                <strong>PARTIALLY PAID</strong>
                                                            </Badge>
                                                        ) : (
                                                            <Badge bg="warning" className="fs-6 p-2 px-4">
                                                                <FaClock className="me-2" />
                                                                <strong>UNPAID</strong>
                                                            </Badge>
                                                        )}
                                                    </div>


                                                </div>
                                                {/* Payment History */}
                                                {/* Enhanced Payment History with Allocation Details */}
                                                {(invoicePaymentHistory.length > 0 || selectedInvoiceDetails?.transaction_allocations?.length > 0) && (
                                                    <Card>
                                                        <Card.Header className="bg-light">
                                                            <h6 className="mb-0 d-flex align-items-center">
                                                                <FaMoneyBillWave className="me-2" />
                                                                Payment History & Allocations
                                                            </h6>
                                                            <small className="text-muted">
                                                                {invoicePaymentHistory.length} payment(s) found
                                                                {selectedInvoiceDetails?.transaction_allocations?.length > 0 &&
                                                                    ` • ${selectedInvoiceDetails.transaction_allocations.length} transaction(s) with allocations`}
                                                            </small>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            {/* Show detailed transaction allocations if available */}
                                                            {selectedInvoiceDetails?.transaction_allocations?.length > 0 && (
                                                                <div className="mb-4">
                                                                    <h6>Transaction Allocation Details</h6>
                                                                    {selectedInvoiceDetails.transaction_allocations.map((transaction, index) => (
                                                                        <div key={transaction.id} className="mb-3 p-3 border rounded">
                                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                <div>
                                                                                    <strong>Transaction #{transaction.reference_no}</strong>
                                                                                    <div className="small text-muted">
                                                                                        Date: {new Date(transaction.date).toLocaleDateString()} |
                                                                                        Method: {transaction.payment_method} |
                                                                                        Status: <Badge bg={transaction.status === 'Completed' ? 'success' : 'warning'}>
                                                                                            {transaction.status}
                                                                                        </Badge>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="text-end">
                                                                                    <div className="text-success">
                                                                                        <strong>Total: {formatUSAmount(transaction.total_amount)}</strong>
                                                                                    </div>
                                                                                    <small className="text-muted">
                                                                                        Allocated: {formatUSAmount(
                                                                                            transaction.allocated_to_invoices.reduce((sum, alloc) =>
                                                                                                sum + parseAmount(alloc.allocated_amount), 0
                                                                                            )
                                                                                        )}
                                                                                    </small>
                                                                                </div>
                                                                            </div>

                                                                            {/* Show bank details if available */}
                                                                            {transaction.account_details && (
                                                                                <div className="small text-muted mb-2">
                                                                                    Bank: {transaction.account_details.account_name}
                                                                                    ({transaction.account_details.account_number})
                                                                                </div>
                                                                            )}

                                                                            {/* Allocation breakdown */}
                                                                            <div className="mt-2">
                                                                                <small className="d-block mb-1"><strong>Allocated to Invoices:</strong></small>
                                                                                {transaction.allocated_to_invoices.map((alloc, idx) => (
                                                                                    <div key={idx} className="d-flex justify-content-between small mb-1">
                                                                                        <span>
                                                                                            <FaCheckCircle className="text-success me-1" size={10} />
                                                                                            {alloc.invoice_ref === selectedInvoiceDetails.ref_no ? (
                                                                                                <strong>{alloc.invoice_ref}</strong>
                                                                                            ) : (
                                                                                                alloc.invoice_ref
                                                                                            )}
                                                                                        </span>
                                                                                        <span className="text-success">
                                                                                            {formatUSAmount(alloc.allocated_amount)}
                                                                                            {alloc.percentage && (
                                                                                                <span className="text-muted ms-1">
                                                                                                    ({alloc.percentage.toFixed(1)}%)
                                                                                                </span>
                                                                                            )}
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>

                                                                            {/* Show unallocated amount if any */}
                                                                            {(() => {
                                                                                const totalAllocated = transaction.allocated_to_invoices.reduce(
                                                                                    (sum, alloc) => sum + parseAmount(alloc.allocated_amount), 0
                                                                                );
                                                                                const unallocated = parseAmount(transaction.total_amount) - totalAllocated;

                                                                                if (unallocated > 0) {
                                                                                    return (
                                                                                        <div className="mt-2 pt-2 border-top">
                                                                                            <div className="d-flex justify-content-between small text-warning">
                                                                                                <span>Unallocated Balance:</span>
                                                                                                <span>{formatUSAmount(unallocated)}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                }
                                                                                return null;
                                                                            })()}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}

                                                            {/* Payment History Table */}
                                                            <Table bordered size="sm" className="mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Date</th>
                                                                        <th>Reference</th>
                                                                        <th>Amount</th>
                                                                        <th>Payment Method</th>
                                                                        <th>Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {invoicePaymentHistory.map((payment, index) => (
                                                                        <tr key={payment.id || index}>
                                                                            <td>
                                                                                {payment.date ?
                                                                                    new Date(payment.date).toLocaleDateString() :
                                                                                    'N/A'}
                                                                            </td>
                                                                            <td>
                                                                                <div>{payment.reference_no || 'N/A'}</div>
                                                                                {payment.account_details && (
                                                                                    <div className="small text-muted">
                                                                                        {payment.account_details.account_name}
                                                                                        {payment.account_details.account_number &&
                                                                                            ` - ${payment.account_details.account_number}`}
                                                                                    </div>
                                                                                )}
                                                                                {payment.note && (
                                                                                    <div className="small text-muted mt-1">
                                                                                        <FaInfoCircle className="me-1" />
                                                                                        {payment.note}
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                            <td className="text-success">
                                                                                <strong>{formatUSAmount(payment.amount)}</strong>
                                                                                {payment.original_amount && payment.original_amount !== payment.amount && (
                                                                                    <div className="small text-muted">
                                                                                        of {formatUSAmount(payment.original_amount)}
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                            <td>{payment.payment_method}</td>
                                                                            <td>
                                                                                <Badge
                                                                                    bg={payment.status === 'Completed' ? 'success' : 'warning'}
                                                                                    className="fs-6"
                                                                                >
                                                                                    {payment.status}
                                                                                </Badge>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    {invoicePaymentHistory.length > 0 && (
                                                                        <tr className="table-active">
                                                                            <td colSpan="2" className="text-end"><strong>Total Paid to this Invoice:</strong></td>
                                                                            <td className="text-success">
                                                                                <strong>
                                                                                    {formatUSAmount(
                                                                                        invoicePaymentHistory.reduce((sum, payment) =>
                                                                                            sum + parseFloat(payment.amount || 0), 0
                                                                                        )
                                                                                    )}
                                                                                </strong>
                                                                            </td>
                                                                            <td colSpan="2"></td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </Table>
                                                        </Card.Body>
                                                    </Card>
                                                )}
                                                {/* Payment Details if available */}
                                                {(selectedInvoiceDetails?.transaction_invoice_items?.length > 0 || selectedInvoiceDetails?.pivot) && (
                                                    <div className="mt-3 p-2 border rounded">
                                                        <h6 className="mb-2">Payment Details</h6>
                                                        {selectedInvoiceDetails.transaction_invoice_items?.map((item, idx) => (
                                                            <div key={idx} className="small mb-1">
                                                                <FaCheckCircle className="text-success me-1" size={12} />
                                                                Paid: <strong>{formatUSAmount(item.paid_amount)}</strong> |
                                                                Balance: <strong>{formatUSAmount(item.balance_amount)}</strong> |
                                                                Status: <Badge bg={item.is_fully_paid ? "success" : "info"} className="fs-7">
                                                                    {item.is_fully_paid ? 'Fully Paid' : 'Partial'}
                                                                </Badge>
                                                            </div>
                                                        ))}
                                                        {selectedInvoiceDetails.pivot?.allocated_amount && !selectedInvoiceDetails.transaction_invoice_items && (
                                                            <div className="small">
                                                                <FaInfoCircle className="text-info me-1" size={12} />
                                                                Paid Amount: <strong>{formatUSAmount(selectedInvoiceDetails.pivot.allocated_amount)}</strong>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })()}
                                </Card.Body>
                            </Card>

                            {/* Quotation Summary */}
                            {(() => {
                                const type = selectedInvoiceDetails.tax_invoice ? 'tax' : 'proforma';
                                const totals = calculateInvoiceTotals(selectedInvoiceDetails, type);

                                if (totals.quotationTotal > 0) {
                                    return (
                                        <Card className="mb-4">
                                            <Card.Header className="bg-light">
                                                <h6 className="mb-0 d-flex align-items-center">
                                                    <FaFileAlt className="me-2" />
                                                    Quotation Summary
                                                </h6>
                                            </Card.Header>
                                            <Card.Body>
                                                <Row className="mb-2">
                                                    <Col sm={8}><strong>Quotation Reference:</strong></Col>
                                                    <Col sm={8}>
                                                        {selectedInvoiceDetails.quotation?.ref_no || 'N/A'}
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Col sm={8}><strong>Quotation Total Amount:</strong></Col>
                                                    <Col sm={4} className="text-end">
                                                        {formatUSAmount(totals.quotationTotal)} {totals.currency}
                                                    </Col>
                                                </Row>
                                                {/* {totals.quotationTotalWithVat > 0 && (
                                                    <Row className="mb-2">
                                                        <Col sm={8}><strong>Quotation Total with VAT:</strong></Col>
                                                        <Col sm={4} className="text-end">
                                                            {formatUSAmount(totals.quotationTotalWithVat)} {totals.currency}
                                                        </Col>
                                                    </Row>
                                                )} */}
                                                <Row className="mb-2">
                                                    <Col sm={8}><strong>This Invoice Amount:</strong></Col>
                                                    <Col sm={4} className="text-end">
                                                        {formatUSAmount(totals.thisInvoiceAmount)} {totals.currency}
                                                        <div className="text-muted small">
                                                            ({((totals.thisInvoiceAmount / totals.quotationTotalWithVat) * 100).toFixed(1)}% of quotation)
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <div className="mt-3 p-2 bg-light rounded">
                                                    <small className="text-muted">
                                                        <FaInfoCircle className="me-1" />
                                                        This invoice is part of quotation {selectedInvoiceDetails.quotation?.ref_no}.
                                                        The quotation total is {formatUSAmount(totals.quotationTotalWithVat || totals.quotationTotal)} {totals.currency}.
                                                    </small>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    );
                                }
                                return null;
                            })()}

                            {/* Tax Invoice Information */}
                            {/* Only show Tax Invoice Information for tax invoices OR proforma invoices with tax invoice generated */}
                            {(selectedInvoiceDetails.tax_invoice ||
                                selectedInvoiceDetails.tax_invoice_generated === "1" ||
                                selectedInvoiceDetails.tax_invoice_generated === true) && (
                                    <Card className="mb-4">
                                        <Card.Header className="bg-light">
                                            <h6 className="mb-0 d-flex align-items-center">
                                                <FaFileInvoice className="me-2" />
                                                Tax Invoice Information
                                            </h6>
                                            {selectedInvoiceDetails.tax_invoice ? (
                                                <small className="text-muted">Tax Invoice Details</small>
                                            ) : (
                                                <small className="text-muted">Generated from Proforma Invoice</small>
                                            )}
                                        </Card.Header>
                                        <Card.Body>
                                            {selectedInvoiceDetails.tax_invoice ? (
                                                // Display full tax invoice details
                                                <>
                                                    <Row className="mb-2">
                                                        <Col sm={4}><strong>Tax Invoice Ref:</strong></Col>
                                                        <Col sm={8}>
                                                            <strong>{selectedInvoiceDetails.tax_invoice.ref_no || 'N/A'}</strong>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col sm={4}><strong>Tax Invoice Date:</strong></Col>
                                                        <Col sm={8}>
                                                            {selectedInvoiceDetails.tax_invoice.date ?
                                                                new Date(selectedInvoiceDetails.tax_invoice.date).toLocaleDateString() :
                                                                'N/A'}
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col sm={4}><strong>VAT Amount:</strong></Col>
                                                        <Col sm={8}>
                                                            {formatUSAmount(selectedInvoiceDetails.tax_invoice.vat_amount || 0)}
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col sm={4}><strong>Total with VAT:</strong></Col>
                                                        <Col sm={8}>
                                                            <strong>{formatUSAmount(selectedInvoiceDetails.tax_invoice.total_with_vat || 0)}</strong>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Col sm={4}><strong>Amount Received:</strong></Col>
                                                        <Col sm={8}>
                                                            <span className="text-success">
                                                                {formatUSAmount(selectedInvoiceDetails.tax_invoice.amount_received || 0)}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                    {selectedInvoiceDetails.tax_invoice.journal_id && (
                                                        <Row className="mb-2">
                                                            <Col sm={4}><strong>Journal ID:</strong></Col>
                                                            <Col sm={8}>
                                                                {selectedInvoiceDetails.tax_invoice.journal_id}
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    {/* {selectedInvoiceDetails.tax_invoice.tax_invoice_file && (
                                                        <Row className="mt-3">
                                                            <Col sm={12}>
                                                                <a
                                                                    href={`${process.env.REACT_APP_BACKEND_URL}/storage/${selectedInvoiceDetails.tax_invoice.tax_invoice_file}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-primary"
                                                                >
                                                                    <FaDownload className="me-1" />
                                                                    Download Tax Invoice Document
                                                                </a>
                                                            </Col>
                                                        </Row>
                                                    )} */}
                                                </>
                                            ) : selectedInvoiceDetails.tax_invoice_generated === "1" || selectedInvoiceDetails.tax_invoice_generated === true ? (
                                                // Display basic tax invoice generation status for proforma invoices
                                                <div className="text-center py-3">
                                                    <div className="mb-3">
                                                        <FaCheckCircle className="text-success mb-2" size={48} />
                                                        <h5>Tax Invoice Generated</h5>
                                                        <p className="text-muted">
                                                            This proforma invoice has a corresponding tax invoice
                                                        </p>
                                                    </div>
                                                    {selectedInvoiceDetails.tax_invoice_file && (
                                                        <div className="mt-3">
                                                            <a
                                                                href={`${process.env.REACT_APP_BACKEND_URL}/storage/${selectedInvoiceDetails.tax_invoice_file}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-sm btn-outline-primary"
                                                            >
                                                                <FaDownload className="me-1" />
                                                                Download Tax Invoice Document
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="text-center py-3">
                                                    <FaClock className="text-warning mb-2" size={32} />
                                                    <p className="text-muted mb-0">Tax invoice not generated yet</p>
                                                </div>
                                            )}
                                        </Card.Body>
                                    </Card>
                                )}
                            {/* Payment History */}

                        </>
                    ) : (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Loading invoice details...</p>
                        </div>
                    )}
                </Offcanvas.Body>

                <div className="border-top p-3">
                    <div className="d-flex justify-content-between align-items-center">

                        <div>
                            <Button
                                variant="secondary"
                                size="sm"
                                onClick={() => setShowDetailsOffcanvas(false)}
                                className="me-2"
                            >
                                Close
                            </Button>

                        </div>
                    </div>
                </div>
            </Offcanvas>
            {showProformaModal && selectedProformaInvoice && (
                <ProformaInvoicePreview
                    invoice={selectedProformaInvoice}
                    showModal={showProformaModal}
                    handleClose={handleCloseProformaModal}
                    quotationData={selectedQuotation}
                    createdInvoice={selectedProformaInvoice}
                    customIntegration={customIntegration}
                    setCustomIntegration={setCustomIntegration}
                    editableDeploymentIntegration={deploymentDescriptions}
                    setEditableDeploymentIntegration={setEditableDeploymentIntegration}
                    customIntegrationDescription={selectedQuotation.custom_integration_description}
                    setCustomIntegrationDescription={setCustomIntegrationDescription}
                    onDownloadPDF={(id, ref) => handleDownloadPDF(id, ref, 'proforma')}
                    onInvoiceUpdate={() => fetchProformaInvoices(1)}
                    fetchInvoices={() => fetchProformaInvoices(1)}
                />
            )}
            {showQuotationModal && selectedQuotation && (
                <QuotationPreviewModal
                    quotation={selectedQuotation}
                    showModal={showQuotationModal}
                    handleClose={handleCloseQuotationModal}
                    clientName={selectedQuotation?.project?.client?.name}
                    projectName={selectedQuotation?.client?.name}
                />
            )}
            {showTaxInvoiceModal && selectedTaxInvoice && (
                <TaxInvoicePreview
                    showModal={showTaxInvoiceModal}
                    handleClose={handleCloseTaxInvoiceModal}
                    createdInvoice={selectedTaxInvoice}
                    quotationData={selectedTaxQuotation}
                    customIntegration={selectedTaxQuotation?.custom_integration}
                    setCustomIntegration={setCustomIntegration}
                    editableDeploymentIntegration={selectedTaxQuotation?.editable_deployment_descriptions ?
                        (typeof selectedTaxQuotation.editable_deployment_descriptions === 'string' ?
                            JSON.parse(selectedTaxQuotation.editable_deployment_descriptions) :
                            selectedTaxQuotation.editable_deployment_descriptions) : {}}
                    setEditableDeploymentIntegration={setEditableDeploymentIntegration}
                    customIntegrationDescription={selectedTaxQuotation?.custom_integration_description}
                    setCustomIntegrationDescription={setCustomIntegrationDescription}
                    onDownloadPDF={(id, ref) => handleDownloadPDF(id, ref, 'tax')}
                    onInvoiceUpdate={refreshTaxInvoices}
                    fetchTaxInvoices={fetchTaxInvoices}
                />
            )}
            <CreditNoteCreateOffcanvas
                show={showCreditNoteOffcanvas}
                handleClose={() => {
                    setShowCreditNoteOffcanvas(false);
                    setSelectedInvoiceForCredit(null);
                }}
                invoice={selectedInvoiceForCredit}
                type={creditNoteType}
                onCreditNoteCreated={handleCreditNoteCreated}
            />
            <CreditNotePreview
                show={showCreditNotePreview}
                handleClose={() => setShowCreditNotePreview(false)}
                creditNote={selectedCreditNote}
                onDownloadPDF={handleCreditNoteDownloadPDF}
            />

        </div>
    );
};

export default InvoiceList;
